import React, { Component } from "react";
import { connect } from "react-redux";
import moment from "moment";

import {
    fetchGet,
    isInteger,
    getDateForSrch,
    get12to24hourtme,
    getDateFormatted2,
    getDateFormatted3
} from "../../common/common";

import store from "../../store";

import LineInp from "../common/lineinput";
import Radio from "../common/radio";
import RadioBlock from "../common/radioBlock";
import Check from "../common/checkbox";
import Header from "../header/header";
import Footer from "../header/footer";
import HeaderSTA from "../header/headerSTA";
import FooterSTA from "../header/footerSTA";
import { apiUrl, color } from "../common/constants";

import PastInput from "../pasthistoryInput/pasthistoryinput";
import {
    updateCheckoutDet,
    updateUserInfo,
    couponListDetails,
    updateHeaderText,
    updateOnwardFare,
    updateLevyAndConcession,
} from "../../actions/search-actions";
import PgBlock from "../common/pgBlock";
import { renderImg } from "../common/icons/img";
import LineInpDrop from "../common/lineInpDrop";
import { PostRequest, convertTimeTo12HourFormat } from "../common/helper";
import HeaderNew from "../header/HeaderNew";
import Checkbox from "../common/input/checkbox";
import AlertTerms from "../common/login/alertTerms";

class CheckoutNew2 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showLoad: true,
            queryData: "{}",
            mobile: window.customerProfile ? window.customerProfile.MobileNumber : '',
            email: window.customerProfile ? window.customerProfile.EmailID : '',
            payopt: "",
            pgname: "",
            insuranceVal: 0,
            insurance: "on",
            onwardFare: 0,
            onwardGst: 0,
            onwardSc: 0,
            returnFare: 0,
            returnGst: 0,
            returnSc: 0,
            onwardPickcharges: 0,
            onwardDropcharges: 0,
            returnPickcharges: 0,
            returnDropcharges: 0,
            onwardRoundTripDiscount: 0,
            returnRoundTripDiscount: 0,
            onwardConvenienceCharge: 0,
            returnConvenienceCharge: 0,
            onwardInsuranceAmt: 0,
            returnInsuranceAmt: 0,
            roundTripdiscount: 0,
            discount: 0,
            isMobile: 0,
            activeTnC: false,
            discountAmt: 0,
            redeemCoupon: false,
            OTP: 0,
            CouponID: 0,
            CouponID2: 0,
            CouponID3: 0,
            CouponDiscount: 0,
            CouponDiscountAmt: 0,
            CouponDiscountAmt2: 0,
            CouponDiscountAmt3: 0,
            CouponDiscountType: "",
            CouponDiscountType2: "",
            CouponDiscountType3: "",
            customerGSTN:
                window.customerProfile && window.customerProfile.GSTN ? "on" : "off",
            companyGSTNo: window.customerProfile ? window.customerProfile.GSTN : "",
            regCompanyName: window.customerProfile
                ? window.customerProfile.GSTCompany
                : "",
            validCouponName: "",
            buttonLabel: "APPLY",
            countryCode: '+91',//window.country_code,
            countryCodeTYpe: window.msurl !== 'shwesanthu.com' ? "indian" : "myanmar",
            prepaidcoupon: "",
            loyaltyCoupon: "",
            marketingCoupon: "",
            updatedStax: 0,
            discountOnBase: 0,
            discountOnTotal: 0,
            bankChargesPer: 0,
            bankCharges: 0,
            showConfirm: false,
            showLoader: false,
            payBtnDisable: false,
            getCouponsDetails: false,
            showCouponblock: false,
            showPayeeBlock: true,
            activeCouponType: "prepaid",
            loyaltyCouponShow: 0,
            prepaidCouponShow: 1,
            discountCouponShow: 0,
            activeNavTab: "review",
            activeRtTab: "farebreakup",
            amountToPay: 0,
            travellerlist: false,
            payeedetail: false,
            isRoundtrip: false,
            showonwardsec: false,
            showreturnsec: false,
            customerName: window.customerProfile
                ? window.customerProfile.CustomerName
                : "",
            customerAge: window.customerProfile ? window.customerProfile.Age : 0,
            customerGender: window.customerProfile
                ? window.customerProfile.Gender === "M"
                    ? "Male"
                    : "Female"
                : "",

            alerterror: "",
            totalcouponAmount: 0,
            removeCoupon: false,
            removeCouponName: "",
            redeemCouponsList: "",
            bookingType: "",
            showServiceCharge: window.showServiceCharge,
            onwardTripSrt: 0,
            returnTripSrt: 0,
            onwardTripSrtConcession: 0,
            returnTripSrtConcession: 0,
            checkTandC: true,
            alredaySelPg: '',
            orderTimestamp: '',
            loginType: 'guest',
            password: '',
            openDrop: {
                'onward': { gender: false, concessionType: false, idCardType: false, country: false }, 'return': { gender: false, concessionType: false, idCardType: false, country: false },
            },
            openDropSeatNo: '',
            genderData: ['Male', 'Female', 'Others'],
            concessionData: [{ index: 0, value: 'General Public' }],
            nationality: ['India'],
            idCardData: ['PAN', 'AADHAR'],
            updatedOnwardFare: 0,
            updatedReturnFare: 0,
            onwardLevyAmount: 0,
            returnLevyAmount: 0,
            onwardConAmt: 0,
            returnConAmt: 0,
            onwardLevyConcData: {},
            returnLevyConcData: {},
            onwardConcList: [],
            tempOnwardConcList: [],
            returnConcList: [],
            tempReturnConcList: [],
            onwardConcessionType: {},
            returnConcessionType: {},
            tempOnwardConcessionType: {},
            tempReturnConcessionType: {},
            levyConcDetailsO: {},
            levyConcDetailsR: {},
            conAmtSeatsO: [],
            selMaxCon: [],
            tempMaxCon: [],
            concessionFilterFor: { age: false, gender: false },
            onwardConcessionUsed: [],
            returnConcessionUsed: [],
            reviewDetail: false,
            reviewEng: true,
            reviewKan: false,
            fareEng: true,
            fareKan: false,
            fareEngR: true,
            fareKanR: false,
            tcFlag: false,
            alertFlag: false,
            gstIn: '',
            gstBusiness: '',
            roundOfFlagO: false,
            roundOfFlagR: false,
            onwardRoundingAmt: 0,
            onwardDiscAmt: 0,
        };
    }

    componentWillMount() {
        const ord = this.props.search.order;
        if (ord.length === 0) {
            let that = this;
            let savedOrderData = JSON.parse(localStorage.getItem('saveOrderdetail'));
            let orderData = savedOrderData.data;
            store.dispatch(updateCheckoutDet(orderData));
        }
    }

    componentDidMount() {
        var urlParams = new URLSearchParams(window.location.search);
        let ord = this.props.search.order;
        let mobile = this.props.search.contactDetail.mobile;
        let email = this.props.search.contactDetail.email;
        if (ord.length === 0) {
            let that = this;
            let savedOrderData = JSON.parse(localStorage.getItem('saveOrderdetail'));
            let savedPassData = JSON.parse(localStorage.getItem('savedPassDet'));
            savedPassData = savedPassData[that.props.match.params.token];
            mobile = savedPassData.mobile;
            email = savedPassData.email;
            let orderData = savedOrderData.data;
            if (orderData.return && orderData.return.routeCode) {
                that.callLevyConc(orderData.return.routeCode, 'return');
            }
            that.callLevyConc(orderData.onward.routeCode);
            store.dispatch(updateCheckoutDet(orderData));
            setTimeout(() => {
                ord = this.props.search.order;
                let onwardFare = this.state.onwardFare;
                let onwardGst = this.state.onwardGst;
                let onwardSc = this.state.onwardSc;
                let returnFare = this.state.returnFare;
                let returnGst = this.state.returnGst;
                let returnSc = this.state.returnSc;
                let discount = this.state.discount;
                let onwardPickcharges = this.state.onwardPickcharges;
                let onwardDropcharges = this.state.onwardDropcharges;
                let returnPickcharges = this.state.returnPickcharges;
                let returnDropcharges = this.state.returnDropcharges;
                let onwardRoundTripDiscount = this.state.onwardRoundTripDiscount;
                let returnRoundTripDiscount = this.state.returnRoundTripDiscount;
                let onwardConvenienceCharge = this.state.onwardConvenienceCharge;
                let returnConvenienceCharge = this.state.returnConvenienceCharge;
                let isRoundtrip = false;
                let headertext1 = "";
                let headertext2 = "";
                let onwardTripSrt = 0;
                let onwardTripSrtConcession = 0;
                let returnTripSrt = 0;
                let returnTripSrtConcession = 0;
                let onwardLevyAmount = 0;
                let returnLevyAmount = 0;
                let onwardConAmt = 0;
                let returnConAmt = 0;
                // headertext1 += ord.onward.fromCity + " ";
                // headertext1 += "- " + ord.onward.toCity;
                // headertext2 += moment(ord.onward.journeyDate + ' ' + ord.onward.boardingTime).format("HH:mm") + ", ";
                // headertext2 += getDateFormatted2(ord.onward.journeyDate) + " - ";
                // headertext2 += moment(ord.onward.arrivalDate + ' ' + ord.onward.arrivalTime).format("HH:mm") + ", ";
                // headertext2 += getDateFormatted2(ord.onward.arrivalDate);
                // store.dispatch(
                //     updateHeaderText({ text1: headertext1, text2: headertext2 })
                // );

                if (ord && ord.onward) {
                    Object.keys(ord.onward.seatDetails).forEach((el) => {
                        //ord.onward.seatDetails[el]["name"] = "";
                        //ord.onward.seatDetails[el]["age"] = "";
                        if (ord.onward.seatDetails[el].age <= 12) {
                            onwardFare += ord.onward.seatDetails[el].childFare;
                        } else {
                            onwardFare += ord.onward.seatDetails[el].fare;
                        }
                        // onwardFare += ord.onward.seatDetails[el].fare;
                        onwardGst += ord.onward.seatDetails[el].serviceTax
                            ? parseInt(ord.onward.seatDetails[el].serviceTax, 10)
                            : 0;

                        let levy = ord.onward.seatDetails[el].l || [];
                        if (levy.length > 0) {
                            levy.forEach(el => {
                                onwardLevyAmount += el.a;
                            })
                        }
                        let concession = ord.onward.seatDetails[el].c || [];
                        if (concession.length > 0) {
                            concession.forEach(el => onwardConAmt += el.a)
                        }
                    });
                    onwardSc += ord.onward.serviceCharge
                        ? parseInt(ord.onward.serviceCharge, 10)
                        : 0;
                    discount += ord.onward.discountAmount
                        ? parseInt(ord.onward.discountAmount, 10)
                        : 0;

                    onwardPickcharges = parseInt(ord.onward.pickupcharge, 10);
                    onwardDropcharges = parseInt(ord.onward.dropoffcharge, 10);
                    onwardRoundTripDiscount = parseInt(ord.onward.onwardRoundtripDiscont, 10);
                    onwardConvenienceCharge = parseInt(ord.onward.ConvenienceCharge, 10);

                }

                if (
                    ord.return &&
                    ord.return.seatDetails &&
                    Object.keys(ord.return.seatDetails).length > 0
                ) {

                    Object.keys(ord.return.seatDetails).forEach((el) => {
                        if (ord.return.seatDetails[el].age <= 12) {
                            returnFare += ord.return.seatDetails[el].childFare;
                        } else {
                            returnFare += ord.return.seatDetails[el].fare;
                        }
                        returnGst += ord.return.seatDetails[el].serviceTax
                            ? parseInt(ord.return.seatDetails[el].serviceTax, 10)
                            : 0;

                        let levy = ord.return.seatDetails[el].l || [];
                        if (levy.length > 0) {
                            levy.forEach(el => {
                                returnLevyAmount += el.a;
                            })
                        }
                        let concession = ord.return.seatDetails[el].c || [];
                        if (concession.length > 0) {
                            concession.forEach(el => returnConAmt += el.a)
                        }
                    });
                    returnSc += ord.return.serviceCharge
                        ? parseInt(ord.return.serviceCharge, 10)
                        : 0;
                    discount += ord.return.discountAmount
                        ? parseInt(ord.return.discountAmount, 10)
                        : 0;
                    isRoundtrip = true;
                }


                if (ord.return) {
                    returnPickcharges = parseInt(ord.return.pickupcharge2, 10);
                    returnDropcharges = parseInt(ord.return.dropoffcharge2, 10);
                    returnRoundTripDiscount = parseInt(
                        ord.return.returnRoundtripDiscont,
                        10
                    );
                    returnConvenienceCharge = parseInt(ord.return.ConvenienceCharge2, 10);
                }
                const roundTripdiscount = (onwardRoundTripDiscount + returnRoundTripDiscount > 0) ? (onwardRoundTripDiscount + returnRoundTripDiscount) : 0;

                let discountAmt;
                if (ord.return && ord.return.discountAmount) {
                    discountAmt =
                        parseInt(ord.onward.discountAmount, 10) +
                        parseInt(ord.return.discountAmount, 10);
                } else {
                    discountAmt = ord && ord.onward && ord.onward.discountAmount;
                }
                ord && Object.keys(ord).length > 0 && this.setDefaultpg(ord.pgDetails);

                const count =
                    ord && ord.onward && ord.onward.seats.length +
                    (ord.return && ord.return.seats ? ord.return.seats.length : 0);
                const insurance = ord && ord.showInsurance ? "on" : "off";
                const insuranceVal = ord && ord.showInsurance ? count * ord.insuranceAmt : 0;
                const onwardInsuranceAmt = ord && ord.showInsurance ? ord.onward.seats.length * ord.insuranceAmt : 0;
                const returnInsuranceAmt = (ord && ord.showInsurance && ord.return && ord.return.seats) ? ord.return.seats.length * ord.insuranceAmt : 0;

                const queryData = JSON.stringify({
                    hop: "direct",
                    mode: returnFare ? "roundtrip" : "oneway",
                    otaId: "0",
                    FromCityId: "",
                    ToCityId: "",
                    fromCityName: ord && ord.onward && ord.onward.fromCity,
                    toCityName: ord && ord.onward && ord.onward.toCity,
                    JourneyDate: ord && ord.onward && ord.onward.journeyDate,
                    NoOfSeats: false,
                    SearchId: 0,
                    returnDate: false,
                });
                this.setState({
                    insurance,
                    insuranceVal,
                    onwardInsuranceAmt,
                    returnInsuranceAmt,
                    onwardFare,
                    onwardGst,
                    onwardSc,
                    returnFare,
                    returnGst,
                    returnSc,
                    queryData,
                    discount,
                    discountAmt,
                    onwardPickcharges,
                    onwardDropcharges,
                    returnPickcharges,
                    returnDropcharges,
                    onwardRoundTripDiscount,
                    returnRoundTripDiscount,
                    onwardConvenienceCharge,
                    returnConvenienceCharge,
                    roundTripdiscount,
                    isRoundtrip,
                    onwardTripSrt,
                    onwardTripSrtConcession,
                    returnTripSrt,
                    returnTripSrtConcession,
                    updatedOnwardFare: onwardFare,
                    updatedReturnFare: returnFare,
                    onwardLevyAmount,
                    returnLevyAmount,
                    onwardConAmt,
                    returnConAmt,
                    mobile,
                    email,
                });
                this.calculateRoundingAmt('onward');
            }, 1000)

        } else {
            const ord = this.props.search.order;
            if (ord.return && ord.return.routeCode) {
                this.callLevyConc(ord.return.routeCode, 'return');
            }
            this.callLevyConc(ord.onward.routeCode);
            let onwardFare = this.state.onwardFare;
            let onwardGst = this.state.onwardGst;
            let onwardSc = this.state.onwardSc;
            let returnFare = this.state.returnFare;
            let returnGst = this.state.returnGst;
            let returnSc = this.state.returnSc;
            let discount = this.state.discount;
            let onwardPickcharges = this.state.onwardPickcharges;
            let onwardDropcharges = this.state.onwardDropcharges;
            let returnPickcharges = this.state.returnPickcharges;
            let returnDropcharges = this.state.returnDropcharges;
            let onwardRoundTripDiscount = this.state.onwardRoundTripDiscount;
            let returnRoundTripDiscount = this.state.returnRoundTripDiscount;
            let onwardConvenienceCharge = this.state.onwardConvenienceCharge;
            let returnConvenienceCharge = this.state.returnConvenienceCharge;
            let isRoundtrip = false;
            let headertext1 = "";
            let headertext2 = "";
            let onwardTripSrt = 0;
            let onwardTripSrtConcession = 0;
            let returnTripSrt = 0;
            let returnTripSrtConcession = 0;
            let onwardLevyAmount = 0;
            let returnLevyAmount = 0;
            let onwardConAmt = 0;
            let returnConAmt = 0;
            // headertext1 += ord.onward.fromCity + " ";
            // headertext1 += "- " + ord.onward.toCity;
            // headertext2 += moment(ord.onward.journeyDate + ' ' + ord.onward.boardingTime).format("HH:mm") + ", ";
            // headertext2 += getDateFormatted2(ord.onward.journeyDate) + " - ";
            // headertext2 += moment(ord.onward.arrivalDate + ' ' + ord.onward.arrivalTime).format("HH:mm") + ", ";
            // headertext2 += getDateFormatted2(ord.onward.arrivalDate);
            // store.dispatch(
            //     updateHeaderText({ text1: headertext1, text2: headertext2 })
            // );
            Object.keys(ord.onward.seatDetails).forEach((el) => {
                //ord.onward.seatDetails[el]["name"] = "";
                //ord.onward.seatDetails[el]["age"] = "";

                if (ord.onward.seatDetails[el].age <= 12) {
                    onwardFare += ord.onward.seatDetails[el].childFare;
                } else {
                    onwardFare += ord.onward.seatDetails[el].fare;
                }
                onwardGst += ord.onward.seatDetails[el].serviceTax
                    ? parseInt(ord.onward.seatDetails[el].serviceTax, 10)
                    : 0;

                let levy = ord.onward.seatDetails[el].l || [];
                if (levy.length > 0) {
                    levy.forEach(el => {
                        onwardLevyAmount += el.a;
                    })
                }
                let concession = ord.onward.seatDetails[el].c || [];
                if (concession.length > 0) {
                    concession.forEach(el => onwardConAmt += el.a)
                }
            });
            onwardSc += ord.onward.serviceCharge
                ? parseInt(ord.onward.serviceCharge, 10)
                : 0;
            discount += ord.onward.discountAmount
                ? parseInt(ord.onward.discountAmount, 10)
                : 0;
            if (
                ord.return &&
                ord.return.seatDetails &&
                Object.keys(ord.return.seatDetails).length > 0
            ) {

                Object.keys(ord.return.seatDetails).forEach((el) => {
                    if (ord.return.seatDetails[el].age <= 12) {
                        returnFare += ord.return.seatDetails[el].childFare;
                    } else {
                        returnFare += ord.return.seatDetails[el].fare;
                    }
                    returnGst += ord.return.seatDetails[el].serviceTax
                        ? parseInt(ord.return.seatDetails[el].serviceTax, 10)
                        : 0;

                    let levy = ord.return.seatDetails[el].l || [];
                    if (levy.length > 0) {
                        levy.forEach(el => {
                            returnLevyAmount += el.a;
                        })
                    }
                    let concession = ord.return.seatDetails[el].c || [];
                    if (concession.length > 0) {
                        concession.forEach(el => returnConAmt += el.a)
                    }
                });
                returnSc += ord.return.serviceCharge
                    ? parseInt(ord.return.serviceCharge, 10)
                    : 0;
                discount += ord.return.discountAmount
                    ? parseInt(ord.return.discountAmount, 10)
                    : 0;
                isRoundtrip = true;
            }
            onwardPickcharges = parseInt(ord.onward.pickupcharge, 10);
            onwardDropcharges = parseInt(ord.onward.dropoffcharge, 10);
            onwardRoundTripDiscount = parseInt(ord.onward.onwardRoundtripDiscont, 10);
            onwardConvenienceCharge = parseInt(ord.onward.ConvenienceCharge, 10);

            if (ord.return) {
                returnPickcharges = parseInt(ord.return.pickupcharge2, 10);
                returnDropcharges = parseInt(ord.return.dropoffcharge2, 10);
                returnRoundTripDiscount = parseInt(
                    ord.return.returnRoundtripDiscont,
                    10
                );
                returnConvenienceCharge = parseInt(ord.return.ConvenienceCharge2, 10);
            }
            const roundTripdiscount = (onwardRoundTripDiscount + returnRoundTripDiscount > 0) ? (onwardRoundTripDiscount + returnRoundTripDiscount) : 0;
            const count =
                ord.onward.seats.length +
                (ord.return && ord.return.seats ? ord.return.seats.length : 0);
            const insurance = ord.showInsurance ? "on" : "off";
            const insuranceVal = ord.showInsurance ? count * ord.insuranceAmt : 0;
            const onwardInsuranceAmt = ord.showInsurance ? ord.onward.seats.length * ord.insuranceAmt : 0;
            const returnInsuranceAmt = (ord.showInsurance && ord.return && ord.return.seats) ? ord.return.seats.length * ord.insuranceAmt : 0;

            const queryData = JSON.stringify({
                hop: "direct",
                mode: returnFare ? "roundtrip" : "oneway",
                otaId: "0",
                FromCityId: "",
                ToCityId: "",
                fromCityName: ord.onward.fromCity,
                toCityName: ord.onward.toCity,
                JourneyDate: ord.onward.journeyDate,
                NoOfSeats: false,
                SearchId: 0,
                returnDate: false,
            });

            let discountAmt;
            if (ord.return && ord.return.discountAmount) {
                discountAmt =
                    parseInt(ord.onward.discountAmount, 10) +
                    parseInt(ord.return.discountAmount, 10);
            } else {
                discountAmt = ord.onward.discountAmount;
            }
            this.setDefaultpg(ord.pgDetails);
            // this.calculateRoundingAmt('onward');
            this.setState({
                insurance,
                insuranceVal,
                onwardInsuranceAmt,
                returnInsuranceAmt,
                onwardFare,
                onwardGst,
                onwardSc,
                returnFare,
                returnGst,
                returnSc,
                queryData,
                discount,
                discountAmt,
                onwardPickcharges,
                onwardDropcharges,
                returnPickcharges,
                returnDropcharges,
                onwardRoundTripDiscount,
                returnRoundTripDiscount,
                onwardConvenienceCharge,
                returnConvenienceCharge,
                roundTripdiscount,
                isRoundtrip,
                onwardTripSrt,
                onwardTripSrtConcession,
                returnTripSrt,
                returnTripSrtConcession,
                updatedOnwardFare: onwardFare,
                updatedReturnFare: returnFare,
                onwardLevyAmount,
                returnLevyAmount,
                onwardConAmt,
                returnConAmt,
                mobile,
                email
            });
        }

        this.deafultSelData();

        window.addEventListener("click", (event) => {
            const target = event.target;
            if (target.tagName.toLowerCase() !== 'input') {
                this.toggleDrop("outside_click");
            }
        });

    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.activeNavTab === "payment") {
            // this.updateSeatDetails();
        }
        if (prevState.levyConcDetailsO !== this.state.levyConcDetailsO || prevState.gstIn !== this.state.gstIn) {
            if (this.state.levyConcDetailsO && Object.keys(this.state.levyConcDetailsO).length > 0) {
                let onward = this.props.search.order.onward;
                let routeCode = onward.routeCode;
                let seatDetails = onward.seatDetails;
                let onwardLevyAmount = 0;
                let onwardLevyConcData = this.state.levyConcDetailsO[routeCode];
                let onwardConcList = onwardLevyConcData.ConcessionList;
                let tempOnwardConcList = onwardConcList;
                Object.keys(seatDetails).forEach((el) => {
                    this.updateOnwardLevy(seatDetails[el], onwardLevyConcData);
                    this.updateOnwardSeatWiseGstNDiscount(seatDetails[el], onwardLevyConcData);
                    let levy = seatDetails[el].l
                    if (levy && levy.length > 0) {
                        levy.forEach((o) => {
                            onwardLevyAmount += o.a;
                        });
                    }
                })

                this.setState({ onwardLevyAmount, onwardConcList, tempOnwardConcList, onwardLevyConcData })
            }
        }

        if (prevState.levyConcDetailsR !== this.state.levyConcDetailsR) {
            if (this.state.levyConcDetailsR && Object.keys(this.state.levyConcDetailsR).length > 0) {
                let ret = this.props.search.order.return;
                let routeCode = ret.routeCode;
                let seatDetails = ret.seatDetails;
                let returnLevyAmount = 0;
                let returnLevyConcData = this.state.levyConcDetailsR[routeCode];
                let returnConcList = returnLevyConcData.ConcessionList;
                let tempReturnConcList = returnConcList;
                Object.keys(seatDetails).forEach((el) => {
                    this.updateReturnLevy(seatDetails[el], returnLevyConcData);
                    let levy = seatDetails[el].l
                    if (levy && levy.length > 0) {
                        levy.forEach((o) => {
                            returnLevyAmount += o.a;
                        });
                    }
                })
                this.setState({ returnLevyAmount, returnConcList, tempReturnConcList, returnLevyConcData })
            }
        }



        if (prevState.roundOfFlagO !== this.state.roundOfFlagO) {
            this.calculateRoundingAmt('onward')
        }

        if (prevState.onwardDiscAmt !== this.state.onwardDiscAmt) {
            this.calculateRoundingAmt('onward')
        }

        if (prevState.onwardLevyAmount !== this.state.onwardLevyAmount) {
            this.calculateRoundingAmt('onward')
        }

        if (prevState.onwardConAmt !== this.state.onwardConAmt) {
            this.calculateRoundingAmt('onward')
        }

    }

    calculateRoundingAmt = (type) => {
        if (type === 'onward') {
            if (this.state.roundOfFlagO) {
                let roundingAmt = 0;
                // console.log(this.state.updatedOnwardFare)
                // console.log(this.state.onwardLevyAmount)
                // console.log(this.state.onwardConAmt);
                // console.log(this.state.onwardDiscAmt)
                let totalOnfare = this.state.updatedOnwardFare - this.state.onwardGst + this.state.onwardLevyAmount - this.state.onwardConAmt - this.state.onwardDiscAmt;
                let round = (totalOnfare) % 10;
                // console.log("totalOnfare", totalOnfare);
                roundingAmt = 10 - round;
                this.setState({ onwardRoundingAmt: roundingAmt });
            }
        }
    }


    callLevyConc = (routeCode, mode) => {
        this.setState({ showLoader: true });
        let levyConcDetailsO = {};
        let levyConcDetailsR = {};
        const api = window.cdnUrl + apiUrl.getLeavyAndConcession + "?routeCode=" + routeCode;
        fetchGet(api).then((data) => {
            // data = {
            //     "ConcessionList": [
            //         {
            //             "AppliedTo": 2,
            //             "ConcessionID": 17,
            //             "ConcessionPer": 0,
            //             "ConcessionTypeID": 4,
            //             "ConcessionTypeName": "GENERAL PUBLIC",
            //             "CorporationID": 1,
            //             "FromDate": "3\/4\/2024 12:00:00 AM",
            //             "Gender": "",
            //             "IsCardEntry": 0,
            //             "IsChild": 1,
            //             "MaxNoOfTicket": 0,
            //             "MaxPersonPerTicket": 2,
            //             "RoundOff": 1,
            //             "StateCodes": "KA,AP,TN,GA,MH,TS,PO",
            //             "ToDate": ""
            //         },
            //         {
            //             "AppliedTo": 2,
            //             "ConcessionID": 18,
            //             "ConcessionPer": 100,
            //             "ConcessionTypeID": 39,
            //             "ConcessionTypeName": "SHAKTI WOMEN CONCESSION",
            //             "CorporationID": 1,
            //             "FromDate": "3\/4\/2024 12:00:00 AM",
            //             "Gender": "F",
            //             "IsCardEntry": 0,
            //             "IsChild": 1,
            //             "MaxNoOfTicket": 24,
            //             "MaxPersonPerTicket": 2,
            //             "RoundOff": 3,
            //             "StateCodes": "KA",
            //             "ToDate": ""
            //         },
            //         {
            //             "AppliedTo": 2,
            //             "ConcessionID": 20,
            //             "ConcessionPer": 100,
            //             "ConcessionTypeID": 40,
            //             "ConcessionTypeName": "SENIOR CITIZEN",
            //             "CorporationID": 1,
            //             "FromDate": "3\/4\/2024 12:00:00 AM",
            //             "Gender": "",
            //             "IsCardEntry": 0,
            //             "IsChild": 0,
            //             "MaxNoOfTicket": 24,
            //             "MaxPersonPerTicket": 2,
            //             "RoundOff": 3,
            //             "StateCodes": "KA",
            //             "ToDate": ""
            //         }
            //     ],
            //     "LevyList": [
            //         {
            //             "AdultAmount": 20,
            //             "ChildAmount": 10,
            //             "CorporationID": 1,
            //             "CorporationLevyID": 7,
            //             "FromDate": "3\/4\/2024 12:00:00 AM",
            //             "IsActive": 1,
            //             "IsPercentage": 0,
            //             "IsRefundable": 1,
            //             "LevyID": 6,
            //             "LevyName": "RESERVATION FEE",
            //             "LevyTypeID": 2,
            //             "MaxBaseFare": 10000,
            //             "MinBaseFare": 0,
            //             "ToDate": "3\/4\/2030 12:00:00 AM"
            //         },
            //         {
            //             "AdultAmount": 2,
            //             "ChildAmount": 1,
            //             "CorporationID": 1,
            //             "CorporationLevyID": 9,
            //             "FromDate": "3\/4\/2024 12:00:00 AM",
            //             "IsActive": 1,
            //             "IsPercentage": 0,
            //             "IsRefundable": 1,
            //             "LevyID": 5,
            //             "LevyName": "ARF",
            //             "LevyTypeID": 2,
            //             "MaxBaseFare": 10000,
            //             "MinBaseFare": 50,
            //             "ToDate": "3\/4\/2030 12:00:00 AM"
            //         },
            //         {
            //             "AdultAmount": 14,
            //             "ChildAmount": 7,
            //             "CorporationID": 1,
            //             "CorporationLevyID": 11,
            //             "FromDate": "3\/4\/2024 12:00:00 AM",
            //             "IsActive": 1,
            //             "IsPercentage": 0,
            //             "IsRefundable": 1,
            //             "LevyID": 8,
            //             "LevyName": "USER FEE",
            //             "LevyTypeID": 2,
            //             "MaxBaseFare": 10000,
            //             "MinBaseFare": 0,
            //             "ToDate": "3\/4\/2030 12:00:00 AM"
            //         }
            //     ],
            //     "Message": "",
            //     "Status": true
            // };
            if (data.Status) {
                if (mode === 'return') {
                    levyConcDetailsR[routeCode] = data;
                    if (data.RoundOf10 == 1) {
                        this.setState({ roundOfFlagR: true })
                    }
                    this.setState({ levyConcDetailsR })
                } else {
                    levyConcDetailsO[routeCode] = data;
                    if (data.RoundOf10 == 1) {
                        this.setState({ roundOfFlagO: true })
                    }
                    this.setState({ levyConcDetailsO })
                }

                this.setState({ showLoader: false });
            }
        })
            .catch((err) => {
                console.log(err)
                this.setState({ showLoader: false });
            })
    }

    deafultSelData = (data) => {
        let that = this;
        const ord = that.props.search.order;
        const onwardloop = ord.length !== 0 ? ord.onward.seats : false;
        const returnloop = ord.length !== 0 ? ord.onward.seats && ord.return && ord.return.seats : false;
        if (data && data.pgSelected) {
            const savedPassData = that.getSavedData();
            if (savedPassData != null) {
                const seats = savedPassData && savedPassData.onward && savedPassData.onward.seatDetails;
                const returnSeats = savedPassData && savedPassData.return && savedPassData.return.seatDetails;
                const alredaySelPg = data.pgSelected;
                const orderTimestamp = data.timestamp;
                const mobile = savedPassData.mobile;
                const email = savedPassData.email;
                if (onwardloop && seats) {
                    onwardloop.map((el) => {
                        store.dispatch(updateUserInfo("name", "onward", el, seats[el].name)),
                            store.dispatch(updateUserInfo("age", "onward", el, seats[el].age)),
                            store.dispatch(updateUserInfo("gender", "onward", el, seats[el].gender)),
                            store.dispatch(updateUserInfo("concessionType", "onward", el, seats[el].concessionType)),
                            store.dispatch(updateUserInfo("idCardType", "onward", el, seats[el].idCardType)),
                            store.dispatch(updateUserInfo("idCardNo", "onward", el, seats[el].idCardNo)),
                            store.dispatch(updateUserInfo("nationality", "onward", el, seats[el].nationality))
                    })
                }

                if (returnloop) {
                    returnloop.map((el) => {
                        store.dispatch(updateUserInfo("name", "return", el, returnSeats[el].name)),
                            store.dispatch(updateUserInfo("age", "return", el, returnSeats[el].age)),
                            store.dispatch(updateUserInfo("gender", "return", el, returnSeats[el].gender)),
                            store.dispatch(updateUserInfo("concessionType", "onward", el, returnSeats[el].concessionType)),
                            store.dispatch(updateUserInfo("idCardType", "onward", el, returnSeats[el].idCardType)),
                            store.dispatch(updateUserInfo("idCardNo", "onward", el, returnSeats[el].idCardNo)),
                            store.dispatch(updateUserInfo("nationality", "onward", el, returnSeats[el].nationality))
                    })
                }

                this.setState({ mobile, email, alredaySelPg, orderTimestamp, travellerlist: true, payeedetail: true, activeNavTab: "payment", payopt: alredaySelPg });
            }

        }
    }

    handlepastlist = (entry, seatno, triptype = "onward") => {
        store.dispatch(updateUserInfo("name", triptype, seatno, entry[0]));
        store.dispatch(
            updateUserInfo("age", triptype, seatno, parseInt(entry[1], 10))
        );
        store.dispatch(updateUserInfo("gender", triptype, seatno, entry[2]));
        // store.dispatch(updateUserInfo("concessionType", triptype, seatno, entry[3]));
        // store.dispatch(updateUserInfo("idCardType", triptype, seatno, entry[4]));
        // store.dispatch(updateUserInfo("idCardNo", triptype, seatno, entry[5]));
        // store.dispatch(updateUserInfo("nationality", triptype, seatno, entry[6]));
        // this.checkConcessionTypeList(entry[2], "gender", triptype);
        //this.checkConcessionTypeList(parseInt(entry[1], 10), "age", triptype)
        this.checkConcessionTypeList(entry[2], parseInt(entry[1], 10), "gender", "age", triptype)
    };
    handleListInput = (filedname, triptype, seatno, val) => {
        if (filedname === "name") {
            /^[a-zA-Z .]+$/.test(val) || val === ""
                ? store.dispatch(updateUserInfo(filedname, triptype, seatno, val))
                : "";
        } else {
            store.dispatch(updateUserInfo(filedname, triptype, seatno, val));
        }
    };

    setDefaultpg = (val) => {
        val.map((el, index) => {
            if (el.IsDefault) {
                this.setState({
                    payopt: el.pg,
                    bankChargesPer: el.BankCharges,
                    pgname: el.DisplayText,
                });
            }
        });
        return true;
    };

    handleClick = (divName) => {
        this.state.activeTnC === false
            ? this.setState({
                activeTnC: divName,
            })
            : this.setState({
                activeTnC: false,
            });
    };

    showTime = (time) => {
        const d = new Date(time);
        const d1 = new Date(d.setMinutes(d.getMinutes() + 20));
        let hour = d1.getHours();
        let mins = d1.getMinutes();
        let AMPM = hour >= 12 ? `PM` : 'AM';
        hour = hour > 12 ? hour - 12 : hour;
        const timeFormat = (hour > 10 ? hour : `0${hour}`) + ':' + (mins > 10 ? mins : `0${mins}`) + ` ${AMPM}`
        return timeFormat;
    }

    selPaymentOption = () => {

        const TotalFare =
            this.state.updatedOnwardFare +
            this.state.updatedReturnFare +
            this.state.onwardSc +
            this.state.returnSc +
            this.state.insuranceVal +
            this.state.onwardPickcharges +
            this.state.onwardDropcharges +
            this.state.returnPickcharges +
            this.state.returnDropcharges;

        let couponDiscount = parseInt(
            this.state.CouponDiscountAmt +
            this.state.CouponDiscountAmt2 +
            this.state.CouponDiscountAmt3 +
            this.state.roundTripdiscount +
            this.state.discount,
            10
        );

        const alredaySelPg = this.state.alredaySelPg;
        const orderTimestamp = this.state.orderTimestamp;

        if (this.state.isRoundtrip) {

            let otDisAmt = 0;

            if (this.state.CouponDiscountAmt > 0 && this.state.CouponDiscountType === "OT") {
                otDisAmt = this.state.CouponDiscountAmt;
            }

            if (this.state.CouponDiscountAmt2 > 0 && this.state.CouponDiscountType2 === "OT") {
                otDisAmt = this.state.CouponDiscountAmt2;
            }

            if (this.state.CouponDiscountAmt3 > 0 && this.state.CouponDiscountType3 === "OT") {
                otDisAmt = this.state.CouponDiscountAmt3;
            }

            let onwardTripFare = this.state.updatedOnwardFare + this.state.onwardPickcharges + this.state.onwardDropcharges + this.state.onwardInsuranceAmt - this.state.discountAmt - this.state.onwardRoundTripDiscount;

            if (otDisAmt > onwardTripFare) {
                //first remove open ticket discount amount from total discount given 
                couponDiscount = couponDiscount - otDisAmt;
                otDisAmt = onwardTripFare;
                //now add new open ticket discount amount in total discount given
                couponDiscount = couponDiscount + otDisAmt;
            }
        }

        if (TotalFare !== couponDiscount) {
            if (
                this.props.search.order &&
                this.props.search.order.pgDetails &&
                this.props.search.order.pgDetails.length > 0
            ) {
                const loop = this.props.search.order.pgDetails;
                const items = [];
                for (const [index, value] of loop.entries()) {
                    items.push(
                        <div key={index} className="pay-opts-item">

                            <PgBlock
                                value={value.pg}
                                selected={this.state.payopt === value.pg ? true : false}
                                onClick={(event) => {
                                    this.setState({
                                        payopt: value.pg,
                                        bankChargesPer: value.BankCharges,
                                        payBtnDisable: false,
                                        pgname: value.pg,
                                        checkTandC: true,
                                    });
                                }}
                                name="PGType"
                            />
                        </div>
                    );
                }
                return (
                    <React.Fragment>
                        <div className="hhh" style={{ padding: '0 16px' }}>
                            <div className="pay-opts" style={{ display: 'flex', justifyContent: 'center', marginTop: '16px' }}>{items}</div>
                            <div className="checkout_tandc" style={{ display: 'flex', marginTop: '20px', fontWeight: '500', fontSize: '14px' }}>
                                <div>
                                    <Checkbox
                                        active={this.state.tcFlag}
                                        onClick={() => this.setState({ tcFlag: !this.state.tcFlag })}
                                    />
                                </div>
                                <div style={{ marginLeft: '16px' }}>I agree to KSRTC's <a style={{ color: '#004F9E', textDecoration: 'underline' }}>Terms & Conditions</a> {/* and <a style={{ color: '#004F9E', textDecoration: 'underline' }}>Privacy Policy</a> */}</div>
                            </div>
                        </div>
                        <div style={{ position: 'absolute', bottom: '0', width: '100%' }}>
                            <div className="final--amount--paid"
                                style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    background: '#fff',
                                    // height: '70px',
                                    fontWeight: '600',
                                    borderRadius: ' 0 0 6px 6px',
                                    color: '#FF7100',
                                    padding: '12px 16px',
                                    alignItems: 'center',
                                    borderTop: '1px solid rgba(0,0,0,0.2)'
                                }}>
                                <div>{this.state.reviewEng ? 'Amount to be Paid' : 'ಪಾವತಿಸಬೇಕಾದ ಮೊತ್ತ'}</div>
                                <div>{this.props.search.currency}{this.amountToPayBlock() + this.bankChargesCalculationBlock()}</div>
                            </div>
                            {this.showPayBtn()}
                        </div>
                        {/* <table>{table}</table> */}
                    </React.Fragment>
                );
            } else {
                return null;
            }
        } else {
            return null;
        }
    };

    isInLocalList(passengerentry) {
        let LocalList = JSON.parse(localStorage.getItem("userinfotable")) || [];
        LocalList.map((el) => { });
        for (var i = 0; i < LocalList.length; i++) {
            if (this.checkequality(passengerentry, LocalList[i])) {
                return true;
            }
        }
        return false;
    }
    checkequality(a, b) {
        var aProps = Object.getOwnPropertyNames(a);
        var bProps = Object.getOwnPropertyNames(b);
        if (aProps.length !== bProps.length) {
            return false;
        }
        for (var i = 0; i < aProps.length; i++) {
            var propName = aProps[i];
            if (a[propName] !== b[propName]) {
                return false;
            }
        }
        if (a != []) {
            return true;
        } else {
            return false;
        }
    }
    showPayBtn = () => {

        const TotalFare = this.state.updatedOnwardFare + this.state.updatedReturnFare + this.state.onwardSc + this.state.returnSc + this.state.insuranceVal;
        let couponDiscount = parseInt(this.state.CouponDiscountAmt + this.state.CouponDiscountAmt2 + this.state.CouponDiscountAmt3 + this.state.roundTripdiscount + this.state.discount, 10);

        if (this.state.isRoundtrip) {

            let otDisAmt = 0;

            if (this.state.CouponDiscountAmt > 0 && this.state.CouponDiscountType === "OT") {
                otDisAmt = this.state.CouponDiscountAmt;
            }

            if (this.state.CouponDiscountAmt2 > 0 && this.state.CouponDiscountType2 === "OT") {
                otDisAmt = this.state.CouponDiscountAmt2;
            }

            if (this.state.CouponDiscountAmt3 > 0 && this.state.CouponDiscountType3 === "OT") {
                otDisAmt = this.state.CouponDiscountAmt3;
            }

            let onwardTripFare = this.state.updatedOnwardFare + this.state.onwardPickcharges + this.state.onwardDropcharges + this.state.onwardInsuranceAmt - this.state.discountAmt - this.state.onwardRoundTripDiscount;

            if (otDisAmt > onwardTripFare) {
                //first remove open ticket discount amount from total discount given 
                couponDiscount = couponDiscount - otDisAmt;
                otDisAmt = onwardTripFare;
                //now add new open ticket discount amount in total discount given
                couponDiscount = couponDiscount + otDisAmt;
            }
        }

        let isActive = false;
        const ord =
            this.props.search.order.length !== 0 ? this.props.search.order : false;
        const currency = this.props.search.currency;
        const amountToPay = this.amountToPayBlock();
        const bankCharges = this.bankChargesCalculationBlock();
        if (ord) {
            let temp = true;
            let conc = true;
            const onwards = ord.onward.seatDetails;
            Object.keys(onwards).forEach((el) => {
                if (!onwards[el].name || !onwards[el].age || !onwards[el].gender) {
                    temp = false;
                }
            });

            Object.keys(onwards).forEach((el) => {
                if (onwards[el].concessionType && onwards[el].concessionType !== 'GENERAL PUBLIC') {
                    if (!onwards[el].concessionType && !onwards[el].idCardType && !onwards[el].idCardType) {
                        temp = false;
                    }
                }

            });

            if (temp && ord.return && ord.return.seats) {
                const returns = ord.return.seatDetails;
                Object.keys(returns).forEach((el) => {
                    if (!returns[el].name || !returns[el].age || !returns[el].gender) {
                        temp = false;
                    }
                });
                Object.keys(returns).forEach((el) => {
                    if (returns[el].concessionType && returns[el].concessionType !== 'GENERAL PUBLIC') {
                        if (returns[el].concessionType && !returns[el].idCardType && !returns[el].idCardType) {
                            temp = false;
                        }
                    }
                });
            }
            let email = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(
                this.state.email
            );
            let countryCode = /^[0-9\-\+]+$/.test(this.state.countryCode);
            let indianMobNo =
                (this.state.mobile + "").length === 10 &&
                /^[0]?[6789]\d{9}$/.test(this.state.mobile);
            let internationalNo =
                (this.state.mobile + "").length < 20 &&
                /^[0-9\-]+$/.test(this.state.mobile);
            let mobile =
                countryCode && this.state.countryCode === "+91"
                    ? indianMobNo
                    : internationalNo;

            if (onwards[ord.onward.seats[0]].age < 13) {
                temp = false;
            } else if (ord.return && ord.return.seats && ord.return.seatDetails && ord.return.seatDetails[ord.return.seats[0]].age < 13) {
                temp = false;
            }
            if (
                temp &&
                email &&
                this.state.email.length > 0 &&
                mobile &&
                countryCode
            ) {
                isActive = true;
            }
        }
        return (
            <div
                className="flex-all-c navswitchbtn"
                style={{
                    color: !isActive ? "#666" : "#fff",
                    background: !isActive ? "#ddd" : color.secondary,
                    boxShadow: "0 0 5px rgba(0, 0, 0, 0.2)",
                    fontWeight: 500,
                    cursor: "pointer",
                    userSelect: "none",
                    left: 0,
                    height: '52px'
                }}
                onClick={this.checkPayment}
            >
                {/* PAY {currency + " " + (amountToPay + bankCharges)} THROUGH{" "}
                {this.state.pgname} */}
                PROCEED TO PAY
            </div>
        );

    };

    showKASRTConwardFaredetails = (order) => {
        let levyFare = {};
        if (order && order.onward && order.onward.seatDetails) {
            Object.keys(order.onward.seatDetails).forEach((el) => {
                let levyList = order.onward.seatDetails[el].l || [];
                if (levyList.length > 0) {
                    levyList.forEach((el) => {
                        if (levyFare[el.n] != undefined) {
                            levyFare[el.n] += el.a;
                        } else {
                            levyFare[el.n] = el.a;
                        }
                    })
                }
            })
        }

        return (
            <React.Fragment>
                <div className="checkout--fare" style={{ position: 'relative' }}>

                    <div> {this.state.reviewEng ? 'Onward Trip Fare Breakup' : 'ಹೋಗುವ ಪ್ರಯಾಣದ ದರಡ ವಿಂಗಡಣೆ'}
                    </div>
                </div>
                <div className="checkout--fare">
                    <div>{this.state.reviewEng ? 'Original Basic Fare' : 'ಮೂಲ ದರ'}</div>
                    <div>{this.props.search.currency}{this.state.updatedOnwardFare - this.state.onwardGst}</div>
                </div>
                {/* <div className="checkout--fare">
          <div>ಸ.ಸೇ.ಶು / GST</div>
          <div>{this.props.search.currency}{this.state.onwardGst}</div>
        </div> */}
                <div className="checkout--fare">
                    <div>{this.state.reviewEng ? 'Levies' : 'ಇತರೆ ಶುಲ್ಕಗಳು'}</div>
                    <div>{this.props.search.currency}{this.state.onwardLevyAmount}</div>
                </div>
                <div className="checkout--fare">
                    <div>{this.state.reviewEng ? 'Concession Amount' : 'ರಿಯಾಯಿತಿ ಮೊತ್ತ'}</div>
                    <div>
                        {"-"}{this.props.search.currency}{this.state.onwardConAmt}
                    </div>
                </div>
                {
                    this.state.onwardDiscAmt > 0 &&
                    <div className="checkout--fare">
                        <div>{this.state.reviewEng ? 'Discount' : 'ರಿಯಾಯಿತಿ'}</div>
                        <div>
                            {"-"}{this.props.search.currency}{this.state.onwardDiscAmt}
                        </div>
                    </div>
                }
                {this.state.onwardRoundingAmt > 0 &&
                    <div className="checkout--fare">
                        <div>{this.state.reviewEng ? 'Round Off' : 'ರೌಂಡ್ ಆಫ್'}</div>
                        <div>
                            {this.props.search.currency}{this.state.onwardRoundingAmt}
                        </div>
                    </div>
                }
                {
                    Object.keys(levyFare).length > 0 &&
                    <div className="checkout--fare">
                        <span style={{ fontSize: '12px', color: '#444' }}>{`(`}
                            {
                                Object.keys(levyFare).map((val, index) => (
                                    <span style={{ fontSize: '12px', color: '#444', fontWeight: '400' }} key={index}>
                                        <span style={{ margin: '0 2px', color: '#444', fontWeight: '400' }}>{val}{":"}</span>
                                        <span style={{ margin: '0 2px', color: '#444', fontWeight: '400' }}>{levyFare[val]}{Object.keys(levyFare).length - 1 < index ? ";" : ''}</span>
                                    </span>
                                ))
                            }
                            {`)`}</span>
                    </div>

                }

                <div className="checkout--fare">
                    <div>{this.state.reviewEng ? 'Onward Fare' : 'ಮುಂದಿನ ಪ್ರಯಾಣ ದರ'}</div>
                    <div>
                        {this.props.search.currency}{this.state.updatedOnwardFare - this.state.onwardGst + this.state.onwardLevyAmount - this.state.onwardConAmt + this.state.onwardRoundingAmt - this.state.onwardDiscAmt}
                    </div>
                </div>

            </React.Fragment>
        )
    }

    showKASRTCreturnFaredetails = (order) => {
        let levyFare = {};
        if (order && order.return && order.return.seatDetails) {
            Object.keys(order.return.seatDetails).forEach((el) => {
                let levyList = order.return.seatDetails[el].l || [];
                if (levyList.length > 0) {
                    levyList.forEach((el) => {
                        if (levyFare[el.n] != undefined) {
                            levyFare[el.n] += el.a;
                        } else {
                            levyFare[el.n] = el.a;
                        }
                    })
                }
            })
        }
        return (
            <React.Fragment>
                <div className="checkout--fare" style={{ position: 'relative' }}>
                    <div>{this.state.reviewKan ? 'ಮುಂದಿನ ಪ್ರಯಾಣ ದರದ ವಿರಾಮ' : 'Return Trip Fare Breakup'}
                    </div>
                </div>
                <div className="checkout--fare">
                    <div>{this.state.reviewKan ? 'ಮೂಲ ದರ' : 'Original Basic Fare'}</div>
                    <div>{this.props.search.currency}{this.state.updatedReturnFare - this.state.returnGst}</div>
                </div>
                {/* <div className="checkout--fare">
          <div>ಸ.ಸೇ.ಶು / GST</div>
          <div>{this.props.search.currency}{this.state.returnGst}</div>
        </div> */}
                <div className="checkout--fare">
                    <div>{this.state.reviewKan ? 'ಇತರೆ ಶುಲ್ಕಗಳು' : 'Levies'}</div>
                    <div>{this.props.search.currency}{this.state.returnLevyAmount}</div>
                </div>
                <div className="checkout--fare">
                    <div>{this.state.reviewKan ? 'ರಿಯಾreviewKanಯಿತಿ ಮೊತ್ತ' : 'Concession Amount'}</div>
                    <div>
                        {"-"}{this.props.search.currency}{this.state.returnConAmt}
                    </div>
                </div>
                {
                    Object.keys(levyFare).length > 0 &&
                    <div className="checkout--fare">
                        <span style={{ fontSize: '12px', color: '#444' }}>{`(`}
                            {
                                Object.keys(levyFare).map((val, index) => (
                                    <span style={{ fontSize: '12px', color: '#444', fontWeight: '400' }} key={index}>
                                        <span style={{ margin: '0 2px', color: '#444', fontWeight: '400' }}>{val}{":"}</span>
                                        <span style={{ margin: '0 2px', color: '#444', fontWeight: '400' }}>{levyFare[val]}{Object.keys(levyFare).length - 1 < index ? ";" : ''}</span>
                                    </span>
                                ))
                            }
                            {`)`}</span>
                    </div>

                }
                <div className="checkout--fare">
                    <div>{this.state.reviewKan ? 'ಪರಿವರ್ತನ ವಾಹನ ಧರ' : 'Return Fare'}</div>
                    <div>
                        {this.props.search.currency}{this.state.updatedReturnFare - this.state.returnGst + this.state.returnLevyAmount - this.state.returnConAmt}
                    </div>
                </div>

            </React.Fragment>
        )
    }

    totalFare = () => {
        var totalFare = 0;
        totalFare =
            this.state.updatedOnwardFare +
            this.state.updatedReturnFare +
            this.state.onwardSc +
            this.state.returnSc +
            this.state.insuranceVal +
            this.state.onwardPickcharges +
            this.state.onwardDropcharges +
            this.state.returnPickcharges +
            this.state.returnDropcharges +
            this.state.onwardTripSrt +
            this.state.returnTripSrt;
        // console.log("totalFare", totalFare);
        return totalFare;
    };

    amountToPayBlock = () => {
        var amountToPay = 0;
        amountToPay =
            this.state.updatedOnwardFare +
            this.state.onwardLevyAmount +
            this.state.returnLevyAmount -
            this.state.onwardConAmt -
            this.state.returnConAmt +
            this.state.updatedReturnFare +
            this.state.onwardSc +
            this.state.returnSc +
            this.state.insuranceVal -
            this.state.roundTripdiscount +
            this.state.onwardPickcharges +
            this.state.onwardDropcharges +
            this.state.returnPickcharges +
            this.state.returnDropcharges +
            this.state.onwardTripSrt -
            this.state.onwardTripSrtConcession +
            this.state.returnTripSrt -
            this.state.returnTripSrtConcession
            - this.state.discount -
            parseInt(
                this.state.CouponDiscountAmt +
                this.state.CouponDiscountAmt2 +
                this.state.CouponDiscountAmt3,
                10
            )
            + this.state.onwardRoundingAmt
            - this.state.onwardDiscAmt;

        // console.log("amountToPay", amountToPay);
        // console.log("round", this.state.roundTripdiscount);
        //for roundtrip and discount coupon applied
        if (this.state.isRoundtrip) {

            let otDisAmt = 0;

            if (this.state.CouponDiscountAmt > 0 && this.state.CouponDiscountType === "OT") {
                otDisAmt = this.state.CouponDiscountAmt;
            }

            if (this.state.CouponDiscountAmt2 > 0 && this.state.CouponDiscountType2 === "OT") {
                otDisAmt = this.state.CouponDiscountAmt2;
            }

            if (this.state.CouponDiscountAmt3 > 0 && this.state.CouponDiscountType3 === "OT") {
                otDisAmt = this.state.CouponDiscountAmt3;
            }

            let onwardTripFare = this.state.updatedOnwardFare + this.state.onwardPickcharges + this.state.onwardDropcharges + this.state.onwardInsuranceAmt - this.state.discountAmt - this.state.onwardRoundTripDiscount;

            if (otDisAmt > onwardTripFare) {
                //first add open ticket discount amount in amount to pay
                amountToPay = amountToPay + otDisAmt;
                otDisAmt = onwardTripFare;
                //then remove new open ticket discount amount in amount to pay
                amountToPay = amountToPay - otDisAmt;
            }
        }

        return amountToPay;
    };

    bankChargesCalculationBlock = () => {
        var amountToPay = this.amountToPayBlock();
        var bankCharges = Math.round(
            (this.state.bankChargesPer * amountToPay) / 100
        );
        return bankCharges;
    };

    bankChargesCalculation = () => {
        var bankCharges = this.bankChargesCalculationBlock();
        return (
            <div className="side-det">
                <div>PG Charges</div>
                <div>
                    {this.props.search.currency}
                    {bankCharges}
                </div>
            </div>
        );
    };

    getCrsDateFormatted = (val) => {
        const split = val.split("-");
        return split[0] + " " + split[1] + ", " + split[2];
    };

    checkInsurance = (e, i) => {
        const count =
            this.props.search.order.onward.seats.length +
            (this.props.search.order.return && this.props.search.order.return.seats
                ? this.props.search.order.return.seats.length
                : 0);
        const insurance = this.state.insurance === "on" ? "off" : "on";
        const totalCouponDis = parseInt(
            this.state.CouponDiscountAmt +
            this.state.CouponDiscountAmt2 +
            this.state.CouponDiscountAmt3,
            10
        );

        const insuranceVal = this.state.insurance === "on" ? 0 : count * this.props.search.order.insuranceAmt;

        const onwardInsuranceAmt = this.state.insurance === "on" ? 0 : this.props.search.order.onward.seats.length * this.props.search.order.insuranceAmt;
        const returnInsuranceAmt = this.state.insurance === "on" ? 0 : (this.props.search.order.return && this.props.search.order.return.seats
            ? this.props.search.order.return.seats.length
            : 0) * this.props.search.order.insuranceAmt;

        if (totalCouponDis > 0) {
            this.setState({ loyaltyCoupon: '', prepaidcoupon: '', marketingCoupon: '', redeemCouponsList: '', CouponName: '' }, () => { this.sendOTP() })
        }

        let alertMsg = insurance == "off" ? "You shall not have insurance for your trip." : "";

        this.setState({ insurance, insuranceVal, onwardInsuranceAmt, returnInsuranceAmt, alerterror: alertMsg });

    };

    HandleContactCheck = (e, i) => {
        // console.log("compulsory block cant uncheck");
    };
    showBankChargesConfirmBox = () => {
        var amountToPay = this.amountToPayBlock();
        var bankCharges = this.bankChargesCalculationBlock();
        var totalFare = amountToPay + bankCharges;
        var bankChargeMsg = window.confirm(
            "The bank charges for the option selected is " +
            (this.props.search.currency + bankCharges) +
            ", Total payable amount is " +
            (this.props.search.currency + totalFare)
        );
        return bankChargeMsg;
    };

    savedPassData = () => {
        let that = this;
        const savedSeatDetails = { onward: {}, return: {}, email: '', mobile: '' };
        const savedData = {};
        if (that.state.alredaySelPg) {
            let savedData = that.getSavedData();
            savedSeatDetails.onward.seatDetails = savedData.onward.seatDetails;
        } else {
            savedSeatDetails.onward.seatDetails = that.props.search.order.onward.seatDetails;
        }
        if (that.props.search.order.return) {
            if (that.state.alredaySelPg) {
                let savedData = that.getSavedData();
                savedSeatDetails.return.seatDetails = savedData.return.seatDetails;
            } else {
                savedSeatDetails.return.seatDetails = that.props.search.order.return.seatDetails;
            }
        }
        savedSeatDetails.email = that.state.email;
        savedSeatDetails.mobile = that.state.mobile;
        savedData[that.props.match.params.token] = savedSeatDetails;
        window.localStorage.setItem("savedPassDet", JSON.stringify(savedData));
    }

    getSavedData = () => {
        let that = this;
        let savedPassData = JSON.parse(localStorage.getItem('savedPassDet'));
        savedPassData = savedPassData[that.props.match.params.token]
        return savedPassData;
    }

    validation = () => {
        var validationError = [];
        var temp = true;
        const ord =
            this.props.search.order.length !== 0 ? this.props.search.order : false;
        if (ord) {
            if (this.state.countryCode === "") {
                validationError.push(" country code");
                temp = false;
            }

            if (this.state.mobile === "") {
                validationError.push(" mobile no");
                temp = false;
            }

            if (this.state.email === "") {
                validationError.push(" email id");
                temp = false;
            }
            const onwards = ord.onward.seatDetails;
            Object.keys(onwards).forEach((el) => {
                if (!onwards[el].name) {
                    validationError.push(" passenger name");
                    temp = false;
                }
                if (!onwards[el].age) {
                    validationError.push(" passenger age");
                    temp = false;
                }
                if (!onwards[el].gender) {
                    validationError.push(" passenger gender");
                    temp = false;
                }
                if (onwards[el].concessionType) {

                    if (!onwards[el].idCardType) {
                        validationError.push(" passenger id card");
                        temp = false;
                    }

                    if (!onwards[el].idCardNo) {
                        validationError.push(" passenger id card no");
                        temp = false;
                    }
                    if (onwards[el].idCardNo && onwards[el].idCardType === 'PAN' && onwards[el].idCardNo.toString().length < 10) {
                        validationError.push("valid PAN");
                        temp = false;
                    }
                    if (onwards[el].idCardNo && onwards[el].idCardType === 'AADHAR' && onwards[el].idCardNo.toString().length < 12) {
                        validationError.push("valid AADHAR");
                        temp = false;
                    }
                }
            });

            if (ord.return && ord.return.seats) {
                const returns = ord.return.seatDetails;
                Object.keys(returns).forEach((el) => {
                    if (!returns[el].name) {
                        validationError.push(" passenger name for return trip");
                        temp = false;
                    }
                    if (!returns[el].age) {
                        validationError.push("passenger age for return trip");
                        temp = false;
                    }
                    if (!returns[el].gender) {
                        validationError.push(" passenger gender for return trip");
                        temp = false;
                    }
                    if (returns[el].concessionType) {

                        if (!returns[el].idCardType) {
                            validationError.push(" passenger id card for return trip");
                            temp = false;
                        }

                        if (!returns[el].idCardNo) {
                            validationError.push(" passenger id card no for return trip");
                            temp = false;
                        }
                        if (returns[el].idCardNo && returns[el].idCardType === 'PAN' && returns[el].idCardNo.toString().length < 10) {
                            validationError.push("valid PAN for return trip");
                            temp = false;
                        }
                        if (returns[el].idCardNo && returns[el].idCardType === 'AADHAR' && returns[el].idCardNo.toString().length < 12) {
                            validationError.push("valid AADHAR for return trip");
                            temp = false;
                        }
                    }
                });
            }

            if (this.state.payopt === "") {
                validationError.push(" payment gateway details");
                temp = false;
            }

            if (temp === false) {
                this.setState({ alerterror: "Kindly enter " + validationError });
            } else {
                let countryCode = /^[0-9\-\+]+$/.test(this.state.countryCode);
                let indianMobNo =
                    (this.state.mobile + "").length === 10 &&
                    /^[0]?[6789]\d{9}$/.test(this.state.mobile);
                let internationalNo =
                    (this.state.mobile + "").length < 20 &&
                    /^[0-9\-]+$/.test(this.state.mobile);
                let mobile =
                    countryCode && this.state.countryCode === "+91"
                        ? indianMobNo
                        : internationalNo;
                let email = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(
                    this.state.email
                );
                if (!mobile) {
                    this.setState({ alerterror: "Kindly enter valid mobile no" });
                } else if (!email) {
                    this.setState({ alerterror: "Kindly enter valid email id" });
                } else {
                    var gstValidation = this.checkGst();
                    if (gstValidation === false) {
                        this.setState({ alerterror: "Kindly enter valid GSTN" });
                    }
                }
            }
        }
    };

    checkPayment = () => {
        let that = this;
        let isActive = false;
        const ord =
            this.props.search.order.length !== 0 ? this.props.search.order : false;
        if (ord) {
            let temp = true;
            let tempAge = true;
            let tempAgeR = true;
            const onwards = ord.onward.seatDetails;
            Object.keys(onwards).forEach((el) => {
                if (!onwards[el].name || !onwards[el].age || !onwards[el].gender) {
                    temp = false;
                }
                if (onwards[el].concessionType && onwards[el].concessionType !== 'GENERAL PUBLIC') {

                    if (!onwards[el].idCardType) {
                        temp = false;
                    }

                    if (!onwards[el].idCardNo) {
                        temp = false;
                    }
                    if (onwards[el].idCardNo && onwards[el].idCardType === 'PAN' && onwards[el].idCardNo.toString().length < 10) {
                        temp = false;
                    }
                    if (onwards[el].idCardNo && onwards[el].idCardType === 'AADHAR' && onwards[el].idCardNo.toString().length < 12) {
                        temp = false;
                    }
                }
            });
            if (ord.return && ord.return.seats) {
                const returns = ord.return.seatDetails;
                Object.keys(returns).forEach((el) => {
                    if (!returns[el].name || !returns[el].age || !returns[el].gender) {
                        temp = false;
                    }

                    if (returns[el].concessionType && returns[el].concessionType !== 'GENERAL PUBLIC') {

                        if (!returns[el].idCardType) {
                            temp = false;
                        }

                        if (!returns[el].idCardNo) {
                            temp = false;
                        }
                        if (returns[el].idCardNo && returns[el].idCardType === 'PAN' && returns[el].idCardNo.toString().length < 10) {
                            temp = false;
                        }
                        if (returns[el].idCardNo && returns[el].idCardType === 'AADHAR' && returns[el].idCardNo.toString().length < 12) {
                            temp = false;
                        }
                    }
                });
            }
            if (onwards[ord.onward.seats[0]].age < 13) {
                tempAge = false;
            } else if (ord.return && ord.return.seats && ord.return.seatDetails && ord.return.seatDetails[ord.return.seats[0]].age < 13) {
                tempAgeR = false;
            }

            let email = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(
                this.state.email
            );
            let countryCode = /^[0-9\-\+]+$/.test(this.state.countryCode);
            let indianMobNo =
                (this.state.mobile + "").length === 10 &&
                /^[0]?[6789]\d{9}$/.test(this.state.mobile);
            let internationalNo =
                (this.state.mobile + "").length < 20 &&
                /^[0-9\-]+$/.test(this.state.mobile);
            let mobile =
                countryCode && this.state.countryCode === "+91"
                    ? indianMobNo
                    : internationalNo;

            if (temp === false) {
                this.setState({ alerterror: "Please enter Valid details" });
            } else if (tempAge === false) {
                this.setState({ alerterror: "1st passenger age should be greater than 12" });
            } else if (tempAgeR === false) {
                this.setState({ alerterror: "1st Return passenger age should be greater than 12" });
            } else if (!email) {
                this.setState({ alerterror: "Please enter valid email id" });
            } else if (!mobile) {
                this.setState({ alerterror: "Please enter valid mobile no" });
            } else if (!countryCode) {
                this.setState({ alerterror: "Please enter valid country code" });
            }

            if (
                temp &&
                tempAge && tempAgeR &&
                email &&
                this.state.email.length > 0 &&
                mobile &&
                countryCode
            ) {
                isActive = true;
                this.setState({ payBtnDisable: true });
            }
        }

        if (!this.state.tcFlag) {
            this.setState({ alertFlag: true })
        }

        if (isActive && this.state.tcFlag) {
            that.updateSeatDetails();
            that.setState({ showLoader: true });
            var confirmBox = this.state.bankChargesPer
                ? 'hidePopup'//this.showBankChargesConfirmBox()
                : true;
            if (!confirmBox) {
                this.setState({ payBtnDisable: false, showLoader: false });
                return false;
            }
            const isGenderCheck =
                window.location.search.split("p=").length > 1
                    ? window.location.search.split("p=")[1].split("&")[0]
                    : false;

            if (isGenderCheck === "1") {
                let counter = 1;
                const routeCode = this.props.search.order.onward.routeCode;
                const loop = this.props.search.order.onward.seatDetails;
                let url =
                    window.url + apiUrl.genderValidate + "?RouteCode=" + routeCode;
                Object.keys(loop).forEach((el) => {
                    url +=
                        "&SeatLabel_" +
                        counter +
                        "=" +
                        el +
                        "&Gender_" +
                        counter +
                        "=" +
                        ((loop[el].gender === "Male" || loop[el].gender === "M") ? "M" : (loop[el].gender === "Female" || loop[el].gender === "F") ? "F" : 'O');
                    counter++;
                });
                fetchGet(url)
                    .then(function (data) {
                        const response = JSON.parse(data).APIBooking_GenderValidationResult;
                        if (response.Status) {
                            that.savedPassData();
                            document.getElementById("checkoutForm").submit();
                        } else {
                            that.setState({
                                showLoader: false,
                                alerterror: response.ErrorMessage,
                            });
                            window.history.back();
                        }
                    })
                    .catch(function (error) {
                        that.setState({ showLoader: false, alerterror: error });
                    });
            } else if (
                this.props.search.order.onward.seatDetails &&
                this.props.search.order.return &&
                this.props.search.order.return.seatDetails
            ) {
                let genderResponse = { onward: false, return: false };
                // let genderError = { onward: false, return: false };

                if (this.props.search.order.onward.seatDetails) {
                    let counter = 1;
                    const routeCode = this.props.search.order.onward.routeCode;
                    const loop = this.props.search.order.onward.seatDetails;
                    let url =
                        window.url + apiUrl.genderValidate + "?RouteCode=" + routeCode;
                    Object.keys(loop).forEach((el) => {
                        url +=
                            "&SeatLabel_" +
                            counter +
                            "=" +
                            el +
                            "&Gender_" +
                            counter +
                            "=" +
                            ((loop[el].gender === "Male" || loop[el].gender === "M") ? "M" : (loop[el].gender === "Female" || loop[el].gender === "F") ? "F" : 'O');
                        counter++;
                    });
                    fetchGet(url)
                        .then(function (data) {
                            const response = JSON.parse(data)
                                .APIBooking_GenderValidationResult;
                            if (response.Status) {
                                genderResponse.onward = true;
                            } else {
                                that.setState({
                                    showLoader: false,
                                    alerterror:
                                        "Onward Trip: Seat check validation error. Please change the seat selected and try again.",
                                });
                                return;
                            }
                        })
                        .catch(function (error) {
                            that.setState({ showLoader: false, alerterror: error });
                        });
                }

                if (
                    this.props.search.order.return &&
                    this.props.search.order.return.seatDetails
                ) {
                    let counter = 1;
                    const routeCode = this.props.search.order.return.routeCode;
                    const loop = this.props.search.order.return.seatDetails;
                    let url =
                        window.url + apiUrl.genderValidate + "?RouteCode=" + routeCode;
                    Object.keys(loop).forEach((el) => {
                        url +=
                            "&SeatLabel_" +
                            counter +
                            "=" +
                            el +
                            "&Gender_" +
                            counter +
                            "=" +
                            ((loop[el].gender === "Male" || loop[el].gender === "M") ? "M" : (loop[el].gender === "Female" || loop[el].gender === "F") ? "F" : 'O');
                        counter++;
                    });
                    fetchGet(url)
                        .then(function (data) {
                            const response = JSON.parse(data)
                                .APIBooking_GenderValidationResult;
                            if (response.Status) {
                                that.savedPassData();
                                document.getElementById("checkoutForm").submit();
                            } else {
                                that.setState({
                                    showLoader: false,
                                    alerterror:
                                        "Return Trip: Seat check validation error. Please change the seat selected and try again.",
                                });
                                return;
                            }
                        })
                        .catch(function (error) {
                            that.setState({ showLoader: false, alerterror: error });
                        });
                }
            } else {
                let that = this;
                that.savedPassData();
                document.getElementById("checkoutForm").submit();
            }
        }
    };

    getMobile = () => {
        let mob = this.props.search.contactDetail.mobile.replace(/\-/g, "");
        const mobNo =
            this.state.countryCode === "+91" ? mob : this.state.countryCode + mob;
        return mobNo;
    };

    showOpDiscountConfirmBox = () => {
        if (this.state.showConfirm) {
            const r = window.confirm(
                "Operator discount has been changed, Do you want to continue with new discount?"
            );
            if (r !== true) {
                const url =
                    window.url +
                    apiUrl.orderDetails +
                    "token=" +
                    this.props.match.params.token;
                const that = this;
                fetchGet(url)
                    .then(function (data) {
                        var info;
                        var mode = "";
                        if (that.state.updatedReturnFare) {
                            info = data.return;
                            mode = "roundtrip";
                        } else {
                            info = data.onward;
                            mode = "oneway";
                        }
                        var fromCityId = info.fromCityId,
                            fromCity = info.fromCity,
                            toCityId = info.toCityId,
                            toCity = info.toCity,
                            departDate = getDateForSrch(info.journeyDate),
                            rsid = info.routeCode,
                            cid = info.companyId;

                        that.props.history.push(
                            "/search?mode=" +
                            mode +
                            "&fromCity=" +
                            fromCityId +
                            "|" +
                            fromCity +
                            "&toCity=" +
                            toCityId +
                            "|" +
                            toCity +
                            "&departDate=" +
                            departDate +
                            "&returnDate=&" +
                            "hop=direct&rsid=" +
                            rsid +
                            "&cid=" +
                            cid +
                            "&src=chkhld&e=-1&apiName=crs"
                        );
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            }
            this.setState({ showConfirm: false });
        }
    };

    apiCouponListNew = () => {
        let that = this;
        let routeCode = that.props.search.order.onward.routeCode;
        let mobile =
            window.customerProfile && window.customerProfile.MobileNumber
                ? window.customerProfile.MobileNumber
                : that.state.mobile;
        let url =
            window.url +
            apiUrl.couponList +
            "?RouteCode=" +
            routeCode +
            "&MobileNumber=" +
            mobile +
            "&EmailID=&CouponName";
        that.setState({ showLoader: true });
        fetchGet(url)
            .then(function (data) {
                that.setState({ showLoader: false });
                store.dispatch(couponListDetails(data));
                that.setState({ getCouponsDetails: true });
            })
            .catch(function (error) {
                that.setState({ showLoader: false });
                console.log(error);
            });
    };

    showaertdialogue = () => {
        setTimeout(() => {
            this.setState({ alerterror: "" });
        }, 5000);
        return (
            <div
                className="blacklayer"
                onClick={() => {
                    this.setState({ alerterror: "" });
                }}
            >
                <div className="popupbox">
                    {/* <div className="circle pixedpos logo-box">
            <GsbLogoBold />
          </div> */}
                    <div className="alertmsg">{this.state.alerterror}</div>
                    <button
                        className="alertbuttonok crsrpointer"
                        onClick={() => {
                            this.setState({ alerterror: "" });
                        }}
                    >
                        OK{" "}
                    </button>
                </div>
            </div>
        );
    };

    HandleTandCCheck = () => {
        let checkTandC = this.state.checkTandC;
        this.setState({ checkTandC: !checkTandC, payopt: '', bankChargesPer: 0 })
    }

    updateUrl = (page) => {
        const pathname = window.location.pathname;
        const queryParam = window.location.search;
        let url = pathname + queryParam;
        if (page === 'payment') {
            url = pathname + queryParam.split('&')[0] + '&page=payment';
        } else {
            url = pathname + queryParam.split('&')[0];
        }
        this.props.history.push(url);
    }

    validatePayeeDetail = () => {
        let loginType = this.state.loginType;
        let validationError = [];
        let temp = true;
        let countryCode = /^[0-9\-\+]+$/.test(this.state.countryCode);
        let indianMobNo =
            (this.state.mobile + "").length === 10 &&
            /^[0]?[6789]\d{9}$/.test(this.state.mobile);
        let internationalNo =
            (this.state.mobile + "").length < 20 &&
            /^[0-9\-]+$/.test(this.state.mobile);
        let mobile =
            countryCode && this.state.countryCode === "+91"
                ? indianMobNo
                : internationalNo;
        let email = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(
            this.state.email
        );
        if (this.state.countryCode === "" && loginType === 'guest') {
            validationError.push(" country code");
            temp = false;
        }
        if (this.state.mobile === "" && loginType === 'guest') {
            validationError.push(" mobile no");
            temp = false;
        }
        if (this.state.email === "") {
            validationError.push(" email id");
            temp = false;
        }
        if (this.state.password === "" && loginType === 'login') {
            validationError.push("password");
            temp = false;
        }
        if (!mobile && this.state.mobile !== "" && loginType === 'guest') {
            validationError.push(" valid mobile no");
            temp = false;
        } else if (!email && this.state.email !== "") {
            validationError.push(" valid email id");
            temp = false;
        } else {
            // var gstValidation = this.checkGst();
            // if (gstValidation === false) {
            //     validationError.push(" valid GSTN");
            //     temp = false;
            // }
        }
        if (temp === false) {
            this.setState({ alerterror: "Kindly enter " + validationError });
            return false;
        } else {
            return temp;
        }
    };

    handlePayee = () => {

        this.validatePayeeDetail() && [
            // this.updateUrl("payment"),
            this.setState({
                activeNavTab: "passengerlist",
                payeedetail: true,
            })
        ]
    }


    reviewInfo = (type) => {
        let order = this.props.search.order;
        let onward = order && order.onward;
        let ret = order && order.return;
        let tripData = JSON.parse(localStorage.getItem('tripData'));
        return (
            <React.Fragment>
                {type === 'onward' &&
                    <React.Fragment>
                        <div className="" style={{ display: 'flex', justifyContent: 'space-between', padding: '16px 0 0 0' }}>
                            <div style={{ fontSize: '14px', fontWeight: '600', lineHeight: '20px', letterSpacing: '.02rem', color: '#202020' }}>{this.state.reviewEng ? `Review Booking` : `ಬುಕ್ಕಿಂಗ್ ಪರಿಶೀಲಿಸು`}</div>
                            <div style={{ fontSize: '12px', fontWeight: '500', lineHeight: '16px', letterSpacing: '.02rem', color: '#444' }}>{this.state.reviewEng ? `Booking as` : `ಬುಕಿಂಗ್ ಅನ್ನು`}: {window.customerProfile.isLoggedIn ? 'Login' : 'Guest'}</div>
                        </div>

                        <div className="pass--info" style={{ display: 'flex', margin: '16px 0', position: 'relative' }}>
                            <LineInp
                                type="text"
                                value={this.state.email || ""}
                                handleChange={(e) => this.setState({ email: e.target.value })}
                                placeholder="Email ID"
                                name="Email ID"
                                validation="email"
                                style={{ width: "calc(33%)", marginRight: "10px" }}
                            />
                            <LineInp
                                type="number"
                                value={this.state.mobile || ""}
                                handleChange={(e) => this.setState({ mobile: e.target.value })}
                                placeholder="Contact Number"
                                name="Contact Number"
                                validation="mobile"
                                style={{ width: "calc(33%)", marginRight: "10px" }}
                            />
                            <div className="checkout_tandc">
                                <Checkbox
                                    active={this.state.gstFlag}
                                    onClick={() => this.setState({ gstFlag: !this.state.gstFlag })}
                                />
                                <span style={{ marginLeft: '8px' }}>I have GSTIN</span>
                            </div>
                            <div className="review-text-wrap" style={{ position: 'absolute', right: '0', display: 'flex', cursor: 'pointer' }}>
                                <div
                                    style={this.state.reviewEng ? { color: '#004F9E' } : { color: '#444' }}
                                    onClick={() => this.setState({ reviewEng: true, reviewKan: false })}
                                > English </div>
                                <div style={{ margin: '0 4px' }}> {" | "} </div>
                                <div
                                    style={this.state.reviewKan ? { color: '#004F9E' } : { color: '#444' }}
                                    onClick={() => this.setState({ reviewEng: false, reviewKan: true })}
                                > Kannada</div>
                            </div>
                        </div>
                        {
                            this.state.gstFlag &&
                            <div className="pass--info" style={{ display: 'flex', margin: '16px 0', position: 'relative' }}>
                                <LineInp
                                    type="text"
                                    value={this.state.gstIn || ""}
                                    handleChange={(e) => this.setState({ gstIn: e.target.value })}
                                    placeholder="GSTIN"
                                    name="gstin"
                                    style={{ width: "calc(33%)", marginRight: "10px" }}
                                />
                                <LineInp
                                    type="text"
                                    value={this.state.gstBusiness || ""}
                                    handleChange={(e) => this.setState({ gstBusiness: e.target.value })}
                                    placeholder="Legal Business Name"
                                    name="Legal Business Name"
                                    style={{ width: "calc(33%)", marginRight: "10px" }}
                                />

                            </div>
                        }
                    </React.Fragment>
                }

                {type === 'onward' &&
                    <div className="" style={{ display: 'flex', justifyContent: 'space-between', padding: '16px 0 8px 0', borderTop: '1px solid rgba(0,0,0,0.2)' }}>
                        <div style={{ fontSize: '14px', fontWeight: '600', lineHeight: '20px', letterSpacing: '.02rem', color: '#202020' }}>{this.state.reviewEng ? `Onward Trip Booking Review` : `ಮುಂದುವರೆದ ಪ್ರಯಾಣ ಬುಕ್ಕಿಂಗ್ ಪರಿಶೀಲಿಸು`}</div>
                        <div style={{ fontSize: '12px', fontWeight: '500', lineHeight: '16px', letterSpacing: '.02rem', color: '#444' }}></div>
                    </div>
                }

                {onward && type === 'onward' &&
                    <div className="review--content" style={{ padding: '8px 0 12px 0' }}>
                        <div className="left">
                            <div className="content">
                                <div>{this.state.reviewEng ? 'OB Reference' : 'OB Reference'}</div>
                                <div>&nbsp;&nbsp;{" : "}&nbsp;{order.orderId}</div>
                            </div>
                            <div className="content" style={{ display: 'flex' }}>
                                <div>{this.state.reviewEng ? 'Date of Journey' : 'ಪ್ರಯಾಣದ ದಿನಾಂಕ'}</div>
                                <div>&nbsp;&nbsp;{" : "}&nbsp;{onward.journeyDate}</div>
                            </div>
                            <div className="content">
                                <div>{this.state.reviewEng ? 'Start Place' : 'ಪ್ರಾರಂಭ ಸ್ಥಳ'}</div>
                                <div>&nbsp;&nbsp;{" : "}&nbsp;{onward.fromCity}</div>
                            </div>
                            <div className="content">
                                <div> {this.state.reviewEng ? 'Boarding Point' : 'ಹತ್ತುವ ಸ್ಥಳಗಳು'}</div>
                                <div>&nbsp;&nbsp;{" : "}&nbsp;{onward.boardingPoint}</div>
                            </div>
                            <div className="content">
                                <div>{this.state.reviewEng ? 'Total Seats' : 'ಒಟ್ಟು ಆಸನಗಳು'}</div>
                                <div>&nbsp;&nbsp;{" : "}&nbsp;{onward.seats.length}</div>
                            </div>
                            <div className="content">
                                <div> {this.state.reviewEng ? 'Departure Time' : 'ನಿರ್ಗಮನ ಸಮಯ'}</div>
                                <div>&nbsp;&nbsp;{" : "}&nbsp;{moment(onward.boardingTime).format("HH:mm")}</div>
                            </div>
                        </div>
                        <div className="right" style={{ width: '50%' }}>
                            <div className="content">
                                <div>{this.state.reviewEng ? 'Trip Code' : 'ಟ್ರಿಪ್ ಕೋಡ್'}</div>
                                <div>&nbsp;&nbsp;{" : "}&nbsp;{tripData.onward.tripCode}</div>
                            </div>
                            <div className="content">
                                <div>{this.state.reviewEng ? 'Class of Service' : 'ಸಾರಿಗೆಯ ವರ್ಗ'}</div>
                                <div>&nbsp;&nbsp;{" : "}&nbsp;{tripData.onward.busServiceType}</div>
                            </div>
                            <div className="content">
                                <div>{this.state.reviewEng ? 'End Place' : 'ಗಮ್ಯ ಸ್ಥಳ'}</div>
                                <div>&nbsp;&nbsp;{" : "}&nbsp;{onward.toCity}</div>
                            </div>
                            <div className="content">
                                <div>{this.state.reviewEng ? 'Alighting Point' : 'ಪ್ರಯಾಣಿಕರು ಇಳಿಯುವ ಸ್ಥಳ'}</div>
                                <div>&nbsp;&nbsp;{" : "}&nbsp;{onward.dropPoint}</div>
                            </div>
                            <div className="content">
                                <div>{this.state.reviewEng ? 'Seat Number' : 'ಆಸನ ಸಂಖ್ಯೆ'}</div>
                                <div>&nbsp;&nbsp;{" : "}&nbsp;{onward.seats.join(',')}</div>
                            </div>
                            <div className="content">
                                <div>{this.state.reviewEng ? 'Platform Number' : 'ಅಂಕಣ ಸಂಖ್ಯೆ'}</div>
                                <div>&nbsp;&nbsp;{" : "}&nbsp;{"-"}</div>
                            </div>
                        </div>
                    </div>
                }

                {ret && type === 'return' && <div className="" style={{ display: 'flex', justifyContent: 'space-between', padding: '23px 0 8px 0', borderTop: '1px solid rgba(0,0,0,0.2)' }}>
                    <div style={{ fontSize: '14px', fontWeight: '600', lineHeight: '20px', letterSpacing: '.02rem', color: '#202020' }}>{this.state.reviewEng ? `Return Trip Booking Review` : `ಹಿಂದೆ ಹೋಗುವ ಪ್ರಯಾಣ ಬುಕಿಂಗ್ ಸಮೀಕ್ಷೆ`} </div>
                </div>
                }

                {ret && Object.keys(ret).length > 0 && type === 'return' &&
                    <div className="review--content">
                        <div className="left">
                            <div className="content">
                                <div>{this.state.reviewEng ? 'OB Reference' : 'OB Reference'}</div>
                                <div>&nbsp;&nbsp;{" : "}&nbsp;{order.orderId}</div>
                            </div>
                            <div className="content" style={{ display: 'flex' }}>
                                <div>{this.state.reviewEng ? 'Date of Journey' : 'ಪ್ರಯಾಣದ ದಿನಾಂಕ'}</div>
                                <div>&nbsp;&nbsp;{" : "}&nbsp;{ret.journeyDate}</div>
                            </div>
                            <div className="content">
                                <div>{this.state.reviewEng ? 'Start Place' : 'ಪ್ರಾರಂಭ ಸ್ಥಳ'}</div>
                                <div>&nbsp;&nbsp;{" : "}&nbsp;{ret.fromCity}</div>
                            </div>
                            <div className="content">
                                <div> {this.state.reviewEng ? 'Boarding Point' : 'ಹತ್ತುವ ಸ್ಥಳಗಳು'}</div>
                                <div>&nbsp;&nbsp;{" : "}&nbsp;{ret.boardingPoint}</div>
                            </div>
                            <div className="content">
                                <div>{this.state.reviewEng ? 'Total Seats' : 'ಒಟ್ಟು ಆಸನಗಳು'}</div>
                                <div>&nbsp;&nbsp;{" : "}&nbsp;{ret.seats.length}</div>
                            </div>
                            <div className="content">
                                <div> {this.state.reviewEng ? 'Departure Time' : 'ನಿರ್ಗಮನ ಸಮಯ'}</div>
                                <div>&nbsp;&nbsp;{" : "}&nbsp;{moment(ret.boardingTime).format('HH:mm')}</div>
                            </div>
                        </div>
                        <div className="right" style={{ width: '50%' }}>
                            <div className="content">
                                <div>{this.state.reviewEng ? 'Trip Code' : 'ಟ್ರಿಪ್ ಕೋಡ್'}</div>
                                <div>&nbsp;&nbsp;{" : "}&nbsp;{tripData.return.tripCode}</div>
                            </div>
                            <div className="content">
                                <div>{this.state.reviewEng ? 'Class of Service' : 'ಸಾರಿಗೆಯ ವರ್ಗ'}</div>
                                <div>&nbsp;&nbsp;{" : "}&nbsp;{tripData.return.busServiceType}</div>
                            </div>
                            <div className="content">
                                <div>{this.state.reviewEng ? 'End Place' : 'ಗಮ್ಯ ಸ್ಥಳ'}</div>
                                <div>&nbsp;&nbsp;{" : "}&nbsp;{ret.toCity}</div>
                            </div>
                            <div className="content">
                                <div>{this.state.reviewEng ? 'Alighting Point' : 'ಪ್ರಯಾಣಿಕರು ಇಳಿಯುವ ಸ್ಥಳ'}</div>
                                <div>&nbsp;&nbsp;{" : "}&nbsp;{ret.dropPoint}</div>
                            </div>
                            <div className="content">
                                <div>{this.state.reviewEng ? 'Seat Number' : 'ಆಸನ ಸಂಖ್ಯೆ'}</div>
                                <div>&nbsp;&nbsp;{" : "}&nbsp;{ret.seats.join(',')}</div>
                            </div>
                            <div className="content">
                                <div>{this.state.reviewEng ? 'Platform Number' : 'ಅಂಕಣ ಸಂಖ್ಯೆ'}</div>
                                <div>&nbsp;&nbsp;{" : "}&nbsp;{"-"}</div>
                            </div>
                        </div>
                    </div>
                }

            </React.Fragment>
        )
    }

    setGender = (value) => {
        if (value === 'M' || value === 'Male') {
            return 'Male';
        } else if (value === 'F' || value === 'Female') {
            return 'Female';
        } else if (value === 'Others' || value === 'o') {
            return 'Others';
        }
    }

    updateSeatDetails() {
        const ord = this.props.search.order;
        if (Object.keys(ord).length) {
            const onwardSeats = ord.onward.seatDetails;
            if (Object.keys(onwardSeats).length) {
                let postData = {};
                postData['token'] = this.props.match.params.token;
                Object.keys(onwardSeats).map((el, index) => {
                    postData[`paxName[${el}]`] = onwardSeats[el].name || '';
                    postData[`paxGender[${el}]`] = onwardSeats[el].gender || '';
                    postData[`paxAge[${el}]`] = onwardSeats[el].age || '';
                    postData[`paxSeat[${el}]`] = el;
                    postData[`paxConcessionType[${el}]`] =
                        onwardSeats[el].concessionType || "";
                    postData[`paxIDCardNo[${el}]`] = onwardSeats[el].idCardNo || "";
                    postData[`paxIDCardType[${el}]`] = onwardSeats[el].idCardType || "";
                    postData[`paxNationality[${el}]`] = onwardSeats[el].nationality || "";
                    postData[`paxLevy[${el}]`] = onwardSeats[el].l || "";
                    postData[`paxConcession[${el}]`] = onwardSeats[el].c || "";
                    postData[`paxDiscount[${el}]`] = onwardSeats[el].Discount || 0;
                });
                if (ord.return) {
                    const returnSeats = ord.return.seatDetails;
                    returnSeats && Object.keys(returnSeats).map((el, index) => {
                        postData[`paxName2[${el}]`] = returnSeats[el].name || '';
                        postData[`paxAge2[${el}]`] = returnSeats[el].age || '';
                        postData[`paxGender2[${el}]`] = returnSeats[el].gender || '';
                        postData[`paxSeat2[${el}]`] = el;
                        postData[`paxConcessionType2[${el}]`] =
                            returnSeats[el].concessionType || "";
                        postData[`paxIDCardNo2[${el}]`] = returnSeats[el].idCardNo || "";
                        postData[`paxIDCardType2[${el}]`] = returnSeats[el].idCardType || "";
                        postData[`paxNationality2[${el}]`] =
                            returnSeats[el].nationality || "";
                        postData[`paxLevy2[${el}]`] = returnSeats[el].l || "";
                        postData[`paxConcession2[${el}]`] = returnSeats[el].c || "";
                    });
                }
                PostRequest('/api/expco/updateBookingSeatDetails', postData).then(response => {
                    if (response.success) {
                        // console.log(response.message);
                    } else {
                        // console.log(response.error.message);
                    }
                }).catch((error) => {
                    console.log(error);
                });
            }
        }
    }

    updateOnwardLevy = (onwardSeats, onwardConLevy, type) => {
        if (
            Object.keys(onwardConLevy).length > 0 &&
            onwardConLevy.LevyList.length > 0
        ) {
            onwardSeats.l = [];
            Object.entries(onwardConLevy.LevyList).forEach(([levyInd, levyObj]) => {
                let fare = 0;
                let levyAmt = 0;
                let calLevyAmt = 0;
                if (onwardSeats.age == "") {
                    fare = onwardSeats.adultFare;
                    levyAmt = levyObj.AdultAmount;
                } else if (onwardSeats.age !== '' && Number(onwardSeats.age) <= 12) {
                    fare = onwardSeats.childFare;
                    levyAmt = levyObj.ChildAmount;
                } else {
                    fare = onwardSeats.adultFare;
                    levyAmt = levyObj.AdultAmount;
                }
                if (fare >= levyObj.MinBaseFare && fare <= levyObj.MaxBaseFare) {
                    if (levyObj.IsPercentage === 0) {
                        calLevyAmt = levyAmt;
                    } else {
                        calLevyAmt = Math.round((fare * levyAmt) / 100);
                    }
                }

                onwardSeats.l.push({
                    id: levyObj.CorporationLevyID,
                    n: levyObj.LevyName,
                    a: calLevyAmt,
                    ir: levyObj.IsRefundable,
                });
            });

            // if (type === 'age') {
            //     let onwardLevyAmount = 0;
            //     let seatDetails = this.props.search.order.onward.seatDetails;
            //     Object.keys(seatDetails).forEach((el) => {
            //         let s = seatDetails[el].l;
            //         if (s && s.length > 0) {
            //             s.forEach((o) => {
            //                 onwardLevyAmount += o.a;
            //             })
            //         }
            //     })
            //     this.setState({ onwardLevyAmount })
            // }

        }
    }

    updateReturnLevy = (returnSeats, returnConLevy, type) => {
        if (
            Object.keys(returnConLevy).length > 0 &&
            returnConLevy.LevyList.length > 0
        ) {
            returnSeats.l = [];

            Object.entries(returnConLevy.LevyList).forEach(([levyInd, levyObj]) => {
                let fare = 0;
                let levyAmt = 0;
                let calLevyAmt = 0;
                if (returnSeats.age == "") {
                    fare = returnSeats.adultFare;
                    levyAmt = levyObj.AdultAmount;
                } else if (returnSeats.age <= 12) {
                    fare = returnSeats.childFare;
                    levyAmt = levyObj.ChildAmount;
                } else {
                    fare = returnSeats.adultFare;
                    levyAmt = levyObj.AdultAmount;
                }

                if (fare >= levyObj.MinBaseFare && fare <= levyObj.MaxBaseFare) {
                    if (levyObj.IsPercentage === 0) {
                        calLevyAmt = levyAmt;
                    } else {
                        calLevyAmt = Math.round((fare * levyAmt) / 100);
                    }
                }

                returnSeats.l.push({
                    id: levyObj.CorporationLevyID,
                    n: levyObj.LevyName,
                    a: calLevyAmt,
                    ir: levyObj.IsRefundable,
                });
            });

            if (type === 'age') {
                let returnLevyAmount = 0;
                let seatDetails = this.props.search.order.return.seatDetails;
                Object.keys(seatDetails).forEach((el) => {
                    let s = seatDetails[el].l;
                    if (s && s.length > 0) {
                        s.forEach((o) => {
                            returnLevyAmount += o.a;
                        })
                    }
                })
                this.setState({ returnLevyAmount })
            }
        }
    }


    updateOnwardSeatWiseGstNDiscount = (onwardSeats, onwardConLevy, type) => {
        const gstInp = this.state.gstIn;
        // console.log("gstin", gstInp);
        // console.log("onwardLevy", onwardConLevy);

        let onward = this.props.search.order.onward;
        let seatDetails = onward.seatDetails;
        const onwardSeatCount = Object.keys(seatDetails).length;

        // console.log("onwardConLevy", onwardConLevy);
        // console.log("count number of seats -> ", onwardSeatCount);

        var discountAmt = 0;
        var totalDiscAmt = 0;
        if (
            onwardConLevy && Object.keys(onwardConLevy).length > 0 &&
            onwardConLevy.GroupDis && Object.keys(onwardConLevy.GroupDis).length > 0 &&
            onwardSeatCount >= onwardConLevy.GroupDis.MinSeat
        ) {
            // console.log("discount applicable");

            var disBaseFare = 0;
            if (onwardSeats.age == "") {
                disBaseFare = onwardSeats.adultFare;
            } else if (onwardSeats.age <= 12) {
                disBaseFare = onwardSeats.childFare;
            } else {
                disBaseFare = onwardSeats.adultFare;
            }

            if (disBaseFare > 0 && onwardConLevy.GroupDis.OnwardPtc > 0) {
                discountAmt = Math.floor(
                    (disBaseFare * onwardConLevy.GroupDis.OnwardPtc) / 100
                );
            }
        }

        var gstPer = 0;
        var gstIsPer = 0;

        //this code is used to get gst percentage from leavy list , where leavy name is GST
        if (
            onwardConLevy && Object.keys(onwardConLevy).length > 0 &&
            onwardConLevy.LevyList && onwardConLevy.LevyList.length > 0
        ) {
            Object.entries(onwardConLevy.LevyList).forEach(([levyInd, levyObj]) => {
                if (levyObj.LevyName == "GST") {
                    let fare = 0;
                    let levyAmt = 0;
                    if (onwardSeats.age == "") {
                        fare = onwardSeats.adultFare;
                        levyAmt = levyObj.AdultAmount;
                    } else if (onwardSeats.age <= 12) {
                        fare = onwardSeats.childFare;
                        levyAmt = levyObj.ChildAmount;
                    } else {
                        fare = onwardSeats.adultFare;
                        levyAmt = levyObj.AdultAmount;
                    }

                    if (fare >= levyObj.MinBaseFare && fare <= levyObj.MaxBaseFare) {
                        if (levyObj.IsPercentage === 0) {
                            gstPer = levyAmt;
                            gstIsPer = 0;
                        } else {
                            gstPer = levyAmt;
                            gstIsPer = 1;
                        }
                    }
                }
            });
        }

        // console.log("gstPer", gstPer);
        // console.log("gstIsPer", gstIsPer);

        var baseFare = 0;
        if (onwardSeats.age == "") {
            baseFare = onwardSeats.adultFare;
        } else if (onwardSeats.age <= 12) {
            baseFare = onwardSeats.childFare;
        } else {
            baseFare = onwardSeats.adultFare;
        }

        // console.log("basefare", baseFare);

        //for calculate total leavy amt
        var totLeavyAmt = 0;
        if (onwardSeats.l && onwardSeats.l.length > 0) {
            onwardSeats.l.forEach((ol) => {
                if (ol.n !== 'GST') {
                    totLeavyAmt += ol.a;
                }
            });
        }

        // console.log("totLeavyAmt", totLeavyAmt);

        //for calculate total concession amt
        var totCancessionAmt = 0;
        if (onwardSeats.c && onwardSeats.c.length > 0) {
            onwardSeats.c.forEach((oc) => {
                totCancessionAmt += oc.a;
            });
        }

        // console.log("totCancessionAmt", totCancessionAmt);

        //for whose amount is greater use this amount either concession or discount
        if (discountAmt > totCancessionAmt) {
            totCancessionAmt = 0;
            if (onwardSeats.c && onwardSeats.c.length > 0) {
                onwardSeats.c.forEach((oc) => {
                    oc.a = 0;
                });
            }
        } else {
            discountAmt = 0;
        }

        var totForGst = baseFare + totLeavyAmt - totCancessionAmt - discountAmt;

        // console.log("totForGst", totForGst);
        var gst = 0;
        var seatWiseIGst = 0;
        var seatWiseCGst = 0;
        var seatWiseSGst = 0;

        if (
            Object.keys(onwardConLevy).length > 0 &&
            onwardConLevy.GSTInfo &&
            Object.keys(onwardConLevy.GSTInfo).length > 0
        ) {
            //corporation has gst for state
            if (
                onwardConLevy.GSTInfo.GSTN != "" &&
                onwardConLevy.GSTInfo.GSTStateCode != ""
            ) {
                // console.log(onwardConLevy.GSTInfo);
                // console.log(onwardConLevy.GSTInfo.GSTN);
                // console.log(onwardConLevy.GSTInfo.GSTStateCode);
                // console.log("customer gst number ", gstInp);
                //if customer has gst number
                if (gstInp) {
                    const customerGSTChar = gstInp.substring(0, 2);
                    if (customerGSTChar == onwardConLevy.GSTInfo.GSTStateCode) {
                        //match then cgst and sgst
                        // console.log(
                            // "customer and company gst state matched then calculate cgst and sgst"
                        // );
                        if (gstIsPer == 1) {
                            seatWiseCGst = Math.ceil((totForGst * gstPer) / 100 / 2);
                            seatWiseSGst = Math.ceil((totForGst * gstPer) / 100 / 2);
                        } else {
                            seatWiseCGst = Math.ceil(gstPer / 2);
                            seatWiseSGst = Math.ceil(gstPer / 2);
                        }
                    } else {
                        //igst
                        // console.log(
                            // "customer and company gst state not matched calculate igst"
                        // );
                        if (gstIsPer == 1) {
                            seatWiseIGst = Math.ceil((totForGst * gstPer) / 100);
                        } else {
                            seatWiseIGst = gstPer;
                        }
                    }
                } else {
                    //customer not have gst then cgst and sgst
                    // console.log("customer not have gst then cgst and sgst");
                    if (gstIsPer == 1) {
                        seatWiseCGst = Math.ceil((totForGst * gstPer) / 100 / 2);
                        seatWiseSGst = Math.ceil((totForGst * gstPer) / 100 / 2);
                    } else {
                        seatWiseCGst = Math.ceil(gstPer / 2);
                        seatWiseSGst = Math.ceil(gstPer / 2);
                    }
                }
            }
        } else {
            //corporation does not have gst then calculate IGST
            // console.log("corporation does not have gst then calculate IGST");
            if (gstIsPer == 1) {
                seatWiseIGst = Math.ceil((totForGst * gstPer) / 100);
            } else {
                seatWiseIGst = gstPer;
            }
        }

        if (seatWiseIGst > 0) {
            gst = seatWiseIGst;
        }
        else {
            gst = seatWiseCGst + seatWiseSGst;
        }

        // console.log("seatWiseIGst", seatWiseIGst);
        // console.log("seatWiseCGst", seatWiseCGst);
        // console.log("seatWiseSGst", seatWiseSGst);
        // console.log("discountAmt", discountAmt);
        // console.log("totCancessionAmt", totCancessionAmt);

        // onwardSeats.IGST = seatWiseIGst;
        // onwardSeats.CGST = seatWiseCGst;
        // onwardSeats.SGST = seatWiseSGst;
        onwardSeats.gst = gst;
        onwardSeats.Discount = discountAmt;

        if (onwardSeats.l && onwardSeats.l.length > 0) {
            onwardSeats.l.forEach((ol) => {
                if (ol.n == 'GST') {
                    ol.a = gst;
                }
            });
        }

        Object.keys(seatDetails).forEach((el) => {
            totalDiscAmt += seatDetails[el].Discount;
        })

        this.setState({ onwardDiscAmt: totalDiscAmt })

        if (type === 'age') {
            let onwardLevyAmount = 0;
            let seatDetails = this.props.search.order.onward.seatDetails;
            Object.keys(seatDetails).forEach((el) => {
                let s = seatDetails[el].l;
                if (s && s.length > 0) {
                    s.forEach((o) => {
                        onwardLevyAmount += o.a;
                    })
                }
            })
            this.setState({ onwardLevyAmount })
        }
    };

    updateOnwardConcessionInfo = (onwardSeats) => {
        onwardSeats.c = [];
        onwardSeats.conAmt = 0;
        // let onwardConAmt = this.state.onwardConAmt;
        // let onwardTempConAmt = onwardConAmt;
        let onwardConAmt = 0;
        if (onwardSeats.concessionType != "") {
            const selectedConType = this.state.tempOnwardConcList.filter(
                (el) =>
                    el.ConcessionTypeName.toLowerCase().trim() ==
                    onwardSeats.concessionType.toLowerCase().trim()
            );

            let conAmt = 0;
            let conPer = selectedConType[0].ConcessionPer;
            let roundOff = selectedConType[0].RoundOff;
            let conFare = 0;
            if (onwardSeats.age != "") {
                if (onwardSeats.age <= 12) {
                    conFare = onwardSeats.childFare;
                } else {
                    conFare = onwardSeats.adultFare;
                }
            }

            if (conFare > 0 && conPer > 0) {
                conAmt = (conFare * conPer) / 100;
            }

            if (conAmt > 0) {
                if (roundOff == 1) {
                    conAmt = Math.floor(conAmt);
                } else if (roundOff == 2) {
                    conAmt = Math.ceil(conAmt);
                } else if (roundOff == 3) {
                    conAmt = Math.round(conAmt);
                }
            }

            onwardSeats.c.push({
                id: selectedConType[0].ConcessionID,
                n: selectedConType[0].ConcessionTypeName,
                a: conAmt,
                pt: onwardSeats.idCardType,
                pv: onwardSeats.idCardNo,
            });
        }
        if (onwardSeats.c.length > 0) {

            onwardSeats.c.forEach((c) => {
                onwardSeats.conAmt = c.a;
            })
        }

        // this.setState({ conAmtSeatsO: onwardSeats })

    };

    updateReturnConcessionInfo = (returnSeats) => {
        returnSeats.c = [];
        returnSeats.conAmt = 0;
        // let returnConAmt = 0;
        if (returnSeats.concessionType != "") {
            const selectedConType = this.state.returnConcList.filter(
                (el) =>
                    el.ConcessionTypeName.toLowerCase().trim() ==
                    returnSeats.concessionType.toLowerCase().trim()
            );

            let conAmt = 0;
            let conPer = selectedConType[0].ConcessionPer;
            let roundOff = selectedConType[0].RoundOff;
            let conFare = 0;
            if (returnSeats.age != "") {
                if (returnSeats.age <= 12) {
                    conFare = returnSeats.childFare;
                } else {
                    conFare = returnSeats.adultFare;
                }
            }

            if (conFare > 0 && conPer > 0) {
                conAmt = (conFare * conPer) / 100;
            }

            if (conAmt > 0) {
                if (roundOff == 1) {
                    conAmt = Math.floor(conAmt);
                } else if (roundOff == 2) {
                    conAmt = Math.ceil(conAmt);
                } else if (roundOff == 3) {
                    conAmt = Math.round(conAmt);
                }
            }

            returnSeats.c.push({
                id: selectedConType[0].ConcessionID,
                n: selectedConType[0].ConcessionTypeName,
                a: conAmt,
                pt: returnSeats.idCardType,
                pv: returnSeats.idCardNo,
            });

            if (returnSeats.c.length > 0) {
                returnSeats.c.forEach((c) => {
                    returnSeats.conAmt = c.a;
                })
            }
            // this.setState({ returnConAmt })
        }
    };

    getConcessionData = (type, seats, seatNo) => {
        if (type === 'onward') {
            let data = {}
            let onwardConcList = this.state.onwardConcList;
            data[seatNo] = onwardConcList.map(el => el.ConcessionTypeName)

            if (seats.concessionType !== '') {
                data[seatNo] = [...new Set([...data[seatNo], seats.concessionType])]

            }
            return data;
        }
        if (type === 'return') {
            let data = {};
            let returnConcList = this.state.returnConcList;
            data[seatNo] = returnConcList.map(el => el.ConcessionTypeName)

            if (seats.concessionType !== '') {
                data[seatNo] = [...new Set([...data[seatNo], seats.concessionType])]
            }
            return data;
        }
    }

    clickHandler = (type, mode, val, seatNo) => {
        let openDrop = this.state.openDrop;
        let openDropSeatNo = seatNo;
        if (mode === 'onward') {
            let onward = this.state.openDrop.onward;
            for (let key in onward) {
                if (key === type) {
                    openDrop[mode][key] = true;
                } else {
                    openDrop[mode][key] = false;
                }
            }
        }
        if (mode === 'return') {
            let openDrop = this.state.openDrop;
            let r = openDrop.return;
            for (let key in r) {
                if (key === type) {
                    openDrop[mode][key] = true;
                } else {
                    openDrop[mode][key] = false;
                }
            }
        }
        this.setState({ openDrop: openDrop, openDropSeatNo })
    }

    reCalculateFare = (type, seatNo, val) => {
        if (type === 'onward') {
            let order = this.props.search.order;
            let seatDetails = order && order.onward && order.onward.seatDetails;;
            let onwardFare = this.state.onwardFare;
            let updatedOnwardFare = this.state.updatedOnwardFare;
            Object.keys(seatDetails).forEach((el) => {
                if (seatDetails[el].age == "") {
                    // updatedOnwardFare += seatDetails[el].fare;
                    // updatedOnwardFare += seatDetails[el].serviceTax;
                    updatedOnwardFare = onwardFare;
                }
                if (seatDetails[el].age && seatDetails[el].age <= 12 && seatDetails[el].childFare > 0) {
                    onwardFare -= (seatDetails[el].fare - seatDetails[el].childFare);
                    updatedOnwardFare = onwardFare;
                }
                if (seatDetails[el].age && seatDetails[el].age > 12) {
                    updatedOnwardFare = onwardFare
                }
            })

            this.setState({ updatedOnwardFare })
        }
        if (type === 'return') {
            let order = this.props.search.order;
            let seatDetails = order && order.return && order.return.seatDetails;;
            let returnFare = this.state.returnFare;
            let updatedReturnFare = this.state.updatedReturnFare;
            // console.log("updatedReturnFare", updatedReturnFare)
            Object.keys(seatDetails).forEach((el) => {
                if (seatDetails[el].age == "") {
                    // updatedReturnFare += seatDetails[el].fare;
                    // updatedReturnFare += seatDetails[el].serviceTax;
                    updatedReturnFare = returnFare;
                }
                if (seatDetails[el].age && seatDetails[el].age <= 12 && seatDetails[el].childFare > 0) {
                    returnFare -= seatDetails[el].childFare;
                    updatedReturnFare = returnFare;
                }
                if (seatDetails[el].age && seatDetails[el].age > 12) {
                    updatedReturnFare = returnFare
                }
            })

            this.setState({ updatedReturnFare })
        }
    }


    recalculateRoundingAmt = (type) => {
        if (type === 'onward') {
            this.calculateRoundingAmt('onward');
        }
    }

    updateConcessionUsed = (type) => {
        const onwardSeats = this.props.search.order.onward.seatDetails;
        if (type === "onward") {
            let tempConcessionUsed = [...this.state.onwardConcessionUsed];
            Object.keys(onwardSeats).forEach((el, index) => {
                if (index <= Object.keys(onwardSeats).length - 1) {
                    if (
                        onwardSeats[el].concessionType != "" &&
                        onwardSeats[el].c &&
                        onwardSeats[el].c.length > 0
                    ) {
                        onwardSeats[el].c.map((el) => {
                            if (tempConcessionUsed[el.n] != undefined) {
                                tempConcessionUsed[el.n] += 1;
                            } else {
                                tempConcessionUsed[el.n] = 1;
                            }
                        });
                    }
                }
            });

            // console.log("tempConcessionUsed", tempConcessionUsed);

            this.setState({ onwardConcessionUsed: tempConcessionUsed });
        }

        if (type === 'return') {
            let returnSeats = this.props.search.order.return.seatDetails;
            let tempConcessionUsed = [...this.state.returnConcessionUsed];

            Object.keys(returnSeats).forEach((el, index) => {
                if (index <= Object.keys(returnSeats).length - 1) {
                    if (
                        returnSeats[el].concessionType != "" &&
                        returnSeats[el].c &&
                        returnSeats[el].c.length > 0
                    ) {
                        returnSeats[el].c.map((el) => {
                            if (tempConcessionUsed[el.n] != undefined) {
                                tempConcessionUsed[el.n] += 1;
                            } else {
                                tempConcessionUsed[el.n] = 1;
                            }
                        });
                    }
                }
            });

            this.setState({ returnConcessionUsed: tempConcessionUsed });
        }
    };


    // checkConcessionTypeList = (value, param, type) => {

    //     console.log({ value, param, type })

    //     let usedConcession;

    //     if (type == "onward") {
    //         usedConcession = this.state.onwardConcessionUsed;
    //     } else {
    //         usedConcession = this.state.returnConcessionUsed;
    //     }

    //     let tempFilter = { ...this.state.concessionFilterFor };
    //     tempFilter[param] = value;
    //     let filterData = [];
    //     if (type === 'onward') {
    //         filterData = this.state.tempOnwardConcList;
    //     } else {
    //         filterData = this.state.tempReturnConcList;
    //     }

    //     if (tempFilter.gender && tempFilter.gender != "") {
    //         filterData = filterData.filter((el) => {
    //             return (
    //                 el.Gender.toLowerCase().trim() == "" ||
    //                 el.Gender.toLowerCase()
    //                     .trim()
    //                     .includes(tempFilter.gender.charAt(0).toLowerCase())
    //             );
    //         });
    //     } else {
    //         if (tempFilter.gender == "") {
    //             filterData = filterData.filter((el) => {
    //                 return (
    //                     el.ConcessionTypeName != 'SENIOR CITIZEN'
    //                 );
    //             });
    //         }
    //     }


    //     if (tempFilter.age && tempFilter.age != "") {
    //         if (tempFilter.age <= 12) {
    //             filterData = filterData.filter((el) => {
    //                 return el.IsChild === 1;
    //             });
    //         } else {
    //             filterData = filterData.filter((el) => {
    //                 return el.IsChild === 0 || el.IsChild === 1;
    //             });
    //         }

    //         if (tempFilter.age <= 60) {
    //             filterData = filterData.filter((el) => {
    //                 return (
    //                     el.ConcessionTypeName != 'SENIOR CITIZEN'
    //                 );
    //             });
    //         }
    //     } else {
    //         if (tempFilter.age == "") {
    //             filterData = filterData.filter((el) => {
    //                 return (
    //                     el.ConcessionTypeName != 'SENIOR CITIZEN'
    //                 );
    //             });
    //         }
    //     }

    //     if (Object.entries(usedConcession).length > 0) {
    //         Object.entries(usedConcession).forEach(([conTitle, conCount]) => {
    //             filterData = filterData.filter((el) => {
    //                 return (
    //                     (el.ConcessionTypeName == conTitle &&
    //                         el.MaxPersonPerTicket > conCount) ||
    //                     el.ConcessionTypeName != conTitle
    //                 );
    //             });
    //         });
    //     }
    //     console.log("filterData", filterData);
    //     if (type === 'onward') {
    //         this.setState({
    //             onwardConcList: filterData,
    //             concessionFilterFor: tempFilter,
    //         });
    //     } else {
    //         this.setState({
    //             returnConcList: filterData,
    //             concessionFilterFor: tempFilter,
    //         });
    //     }
    // };


    checkConcessionTypeList = (gender, age, param1, param2, type) => {

        // console.log({ gender, age, param1, param2, type })

        let usedConcession;

        if (type == "onward") {
            usedConcession = this.state.onwardConcessionUsed;
        } else {
            usedConcession = this.state.returnConcessionUsed;
        }

        let tempFilter = { ...this.state.concessionFilterFor };
        // tempFilter[param] = value;
        let filterData = [];
        if (type === 'onward') {
            filterData = this.state.tempOnwardConcList;
        } else {
            filterData = this.state.tempReturnConcList;
        }
        // console.log("filterDate", filterData);
        if (gender != "" && age == "") {
            filterData = filterData.filter((el) => {
                return (
                    el.Gender.toLowerCase().trim() == "" ||
                    el.Gender.toLowerCase()
                        .trim()
                        .includes(gender.charAt(0).toLowerCase()) || el.ConcessionTypeName != 'SENIOR CITIZEN'
                );
            });
        }

        if (gender == "" && age == "") {
            filterData = filterData.filter((el) => {
                return (
                    el.ConcessionTypeName != 'SENIOR CITIZEN'
                );
            });
        }

        if (gender != "" && age != "") {
            // console.log("helososos");
            // console.log(age);
            // console.log(typeof age);
            if (age <= 60) {
                filterData = filterData.filter((el) => {
                    return (
                        el.ConcessionTypeName != 'SENIOR CITIZEN' && el.Gender.toLowerCase().trim() == "" ||
                        el.Gender.toLowerCase()
                            .trim()
                            .includes(gender.charAt(0).toLowerCase())
                    );
                });
            }

            if (age > 60) {
                // console.log("hello");
                filterData = filterData.filter((el) => {
                    return (
                        el.Gender.toLowerCase().trim() == "" ||
                        el.Gender.toLowerCase()
                            .trim()
                            .includes(gender.charAt(0).toLowerCase())
                    );
                });
            }

        }



        if (Object.entries(usedConcession).length > 0) {
            Object.entries(usedConcession).forEach(([conTitle, conCount]) => {
                filterData = filterData.filter((el) => {
                    return (
                        (el.ConcessionTypeName == conTitle &&
                            el.MaxPersonPerTicket > conCount) ||
                        el.ConcessionTypeName != conTitle
                    );
                });
            });
        }
        // console.log("filterData", filterData);
        if (type === 'onward') {
            this.setState({
                onwardConcList: filterData,
                concessionFilterFor: tempFilter,
            });
        } else {
            this.setState({
                returnConcList: filterData,
                concessionFilterFor: tempFilter,
            });
        }
    };

    toggleDrop = (mode) => {
        let openDrop = this.state.openDrop;
        if (mode === 'onward') {
            let onward = this.state.openDrop.onward;
            for (let key in onward) {
                openDrop[mode][key] = false;
            }
            this.setState({ openDrop: openDrop })
        }
        if (mode === 'return') {
            let openDrop = this.state.openDrop;
            let r = openDrop.return;
            for (let key in r) {
                openDrop[mode][key] = false;
            }
            this.setState({ openDrop: openDrop })
        }
        if (mode === 'outside_click') {
            let onward = this.state.openDrop.onward;
            for (let key in onward) {
                openDrop['onward'][key] = false;
            }
            let returnMode = this.state.openDrop.return;
            for (let key in returnMode) {
                openDrop['return'][key] = false;
            }
            this.setState({ openDrop: openDrop })
        }

    }

    handleDropData = (index, type, seatNo, seatsData, selval) => {
        // console.log({ index, type, seatNo, seatsData })
        if (type === 'onward_gender') {
            let gender = this.setGender(selval)
            store.dispatch(
                updateUserInfo(
                    "gender",
                    "onward",
                    seatNo,
                    gender
                )
            );
            // this.checkConcessionTypeList(gender, seatsData.age, "gender", 'age', 'onward');
            this.checkConcessionTypeList(gender, seatsData.age, 'gender', 'age', 'onward')
            store.dispatch(updateUserInfo("concessionType", "onward", seatNo, ""));
            this.updateOnwardConcessionInfo(seatsData);
            this.updateConcessionUsed('onward');
            this.updateConcessionAmount('onward');
            this.recalculateRoundingAmt('onward');
            this.toggleDrop('onward');
            setTimeout(() => {
                // this.checkConcessionTypeList(gender, "gender", 'onward');
                // this.checkConcessionTypeList(gender, seatsData.age, "gender", 'age', 'onward');
                this.checkConcessionTypeList(gender, seatsData.age, 'gender', 'age', 'onward')
            }, 100)
        }
        if (type === 'onward_concession') {
            store.dispatch(
                updateUserInfo(
                    "concessionType",
                    "onward",
                    seatNo,
                    selval
                )
            );
            this.updateOnwardConcessionInfo(seatsData);
            this.updateConcessionAmount('onward');
            this.updateConcessionUsed('onward');
            this.toggleDrop('onward');
            this.recalculateRoundingAmt('onward');
        }
        if (type === 'onward_idCardType') {
            // let countryData = this.state.idCardData
            // let selIdCrad = countryData.filter(el => index === el.index)[0];
            store.dispatch(
                updateUserInfo(
                    "idCardType",
                    "onward",
                    seatNo,
                    selval
                )
            );
            this.toggleDrop('onward')
        }
        if (type === 'onward_country') {

            store.dispatch(
                updateUserInfo(
                    "nationality",
                    "onward",
                    seatNo,
                    selval
                )
            );
            this.toggleDrop('onward')
        }

        if (type === 'return_gender') {
            let gender = this.setGender(selval)
            store.dispatch(
                updateUserInfo(
                    "gender",
                    "return",
                    seatNo,
                    gender,
                )
            );
            // this.checkConcessionTypeList(gender, "gender", 'return');
            // this.checkConcessionTypeList(gender, seatsData.age, "gender", 'age', 'return');
            this.checkConcessionTypeList(gender, seatsData.age, 'gender', 'age', 'return')
            store.dispatch(updateUserInfo("concessionType", "return", seatNo, ""));
            this.updateReturnConcessionInfo(seatsData);
            this.updateConcessionUsed('return');
            this.updateConcessionAmount('return');
            this.toggleDrop('return')
            setTimeout(() => {
                // this.checkConcessionTypeList(gender, "gender", 'return');
                // this.checkConcessionTypeList(gender, seatsData.age, "gender", 'age', 'return');
                this.checkConcessionTypeList(gender, seatsData.age, 'gender', 'age', 'return')
            }, 0)
        }
        if (type === 'return_concession') {
            store.dispatch(
                updateUserInfo(
                    "concessionType",
                    "return",
                    seatNo,
                    selval
                )
            );
            this.updateReturnConcessionInfo(seatsData);
            this.updateConcessionAmount('return');
            this.updateConcessionUsed('return');
            this.toggleDrop('return')
        }
        if (type === 'return_idCardType') {
            store.dispatch(
                updateUserInfo(
                    "idCardType",
                    "return",
                    seatNo,
                    selval
                )
            );
            this.toggleDrop('return')
        }
        if (type === 'return_country') {
            store.dispatch(
                updateUserInfo(
                    "nationality",
                    "return",
                    seatNo,
                    selval
                )
            );
            this.toggleDrop('return')
        }
    }


    updateConcessionAmount = (type) => {
        if (type === 'onward') {
            let conAmt = 0;
            let seatDetails = this.props.search.order.onward.seatDetails;
            Object.keys(seatDetails).forEach(el => {
                conAmt += seatDetails[el].conAmt;
            })
            this.setState({ onwardConAmt: conAmt })
        }
        if (type === 'return') {
            let conAmt = 0;
            let seatDetails = this.props.search.order.return.seatDetails;
            Object.keys(seatDetails).forEach(el => {
                conAmt += seatDetails[el].conAmt;
            })
            this.setState({ returnConAmt: conAmt })
        }
    }

    enterPassDetailsOnwards = () => {
        const ord = this.props.search.order;
        const loop = ord.length !== 0 ? ord.onward.seats : false;
        const urlParams = new URLSearchParams(window.location.search);
        const linkfromstoptocity = urlParams.get("linkfromstoptocity");
        if (loop) {
            const seats = ord.onward.seatDetails;
            return (
                <React.Fragment>
                    <div className="passenger--trip--head">{this.state.reviewEng ? `Onward Trip Passenger${loop.length > 1 ? 's' : ''}` : `ಮುಂದುವರೆದ ಪ್ರಯಾಣಿಕರು`}</div>
                    {loop.map((el, index) => {
                        return (
                            <div className="pass-info" key={el}>
                                <div
                                    style={{
                                        position: "relative",
                                        width: "45px",
                                        height: "45px",
                                        fontSize: "14px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        border: "2px solid",
                                        borderColor: seats[el].isMale
                                            ? color.grey
                                            : seats[el].isFemale
                                                ? color.female
                                                : color.grey,
                                        borderRadius: color.borderRadius,
                                    }}
                                >
                                    {el}
                                    <span
                                        style={{
                                            position: "absolute",
                                            bottom: 0,
                                            left: "9px",
                                            width: "23px",
                                            height: "4px",
                                            background: seats[el].isMale
                                                ? color.grey
                                                : seats[el].isFemale
                                                    ? color.female
                                                    : color.grey,
                                            borderRadius: color.borderRadius,
                                        }}
                                    ></span>
                                </div>
                                <PastInput
                                    value={seats[el].name || ""}
                                    handleSelect={this.handlepastlist}
                                    handleChange={this.handleListInput}
                                    name={"paxName[" + index + "]"}
                                    placeholder="Name"
                                    style={{ width: "18%" }}
                                    filedname="name"
                                    triptype="onward"
                                    seatno={el}
                                    tab={index * 4 + 3}
                                    autoFocus={
                                        this.state.activeNavTab === "passengerlist" && index === 0
                                    }
                                />
                                <LineInpDrop
                                    type="text"
                                    value={this.setGender(seats[el].gender) || ""}
                                    // handleChange={(e) => {
                                    //   index === 0
                                    //     ? this.setState({ customerAge: e.target.value })
                                    //     : "";
                                    //   const val = isInteger(parseInt(e.target.value, 10))
                                    //     ? parseInt(e.target.value, 10)
                                    //     : !e.target.value
                                    //       ? ""
                                    //       : seats[el].age;
                                    //   store.dispatch(updateUserInfo("age", "onward", el, val));
                                    // }}
                                    onClick={() => {
                                        this.clickHandler('gender', 'onward', seats[el], el)
                                        //this.checkConcessionTypeList(seats[el].gender, 'gender', 'onward')
                                        //this.checkConcessionTypeList(seats[el].age, 'age', 'onward')
                                        this.checkConcessionTypeList(seats[el].gender, seats[el].age, 'gender', 'age', 'onward')
                                    }
                                    }
                                    placeholder="Gender"
                                    name={"paxGender[" + index + "]"}
                                    style={{ width: "10%" }}
                                    tab={index * 4 + 4}
                                    seatNo={el}
                                    readOnly={true}
                                    disabled={(seats[el].isFemale || seats[el].isMale) ? true : false}
                                    dropType={'onward_gender'}
                                    data={this.state.genderData}
                                    openDrop={this.state.openDrop['onward']['gender'] && this.state.openDropSeatNo === el}
                                    handleDropData={this.handleDropData}
                                    seatsData={seats[el]}
                                />
                                <LineInp
                                    type="tel"
                                    value={seats[el].age || ""}
                                    handleChange={(e) => {
                                        index === 0
                                            ? this.setState({ customerAge: e.target.value })
                                            : "";
                                        const val = isInteger(parseInt(e.target.value, 10))
                                            ? parseInt(e.target.value, 10)
                                            : !e.target.value
                                                ? ""
                                                : seats[el].age;
                                        store.dispatch(updateUserInfo("age", "onward", el, val));
                                        store.dispatch(updateUserInfo("concessionType", "onward", el, ""));
                                        // this.checkConcessionTypeList(seats[el].age, "age", 'onward');
                                        this.checkConcessionTypeList(seats[el].gender, seats[el].age, 'gender', 'age', 'onward')
                                        this.reCalculateFare('onward', el, seats[el].age + '');
                                        this.updateOnwardLevy(seats[el], this.state.onwardLevyConcData, 'age');
                                        this.updateOnwardSeatWiseGstNDiscount(seats[el], this.state.onwardLevyConcData, 'age');
                                        this.updateOnwardConcessionInfo(seats[el]);
                                        this.updateConcessionAmount('onward');
                                        setTimeout(() => {
                                            this.recalculateRoundingAmt('onward');
                                        }, 1000)
                                    }}
                                    placeholder="Age"
                                    name={"paxAge[" + index + "]"}
                                    style={{ width: "8%" }}
                                    tab={index * 4 + 5}
                                    max={2}
                                />
                                <LineInpDrop
                                    type="text"
                                    value={seats[el].concessionType || ""}
                                    onClick={() => {
                                        this.clickHandler('concessionType', 'onward', seats[el], el)
                                        //this.checkConcessionTypeList(seats[el].age, "age", 'onward');
                                        //this.checkConcessionTypeList(seats[el].gender, 'gender', 'onward')
                                        this.checkConcessionTypeList(seats[el].gender, seats[el].age, 'gender', 'age', 'onward')
                                    }}
                                    placeholder="Concession"
                                    name={"paxConcessionType[" + index + "]"}
                                    style={{ width: "18%" }}
                                    tab={index * 4 + 6}
                                    readOnly={true}
                                    seatNo={el}
                                    dropType={'onward_concession'}
                                    // data={this.getConcessionData('onward', el)[el]}
                                    // data={this.state.onwardConcessionType[el]}
                                    data={this.getConcessionData('onward', seats[el], el)[el] || []}
                                    handleDropData={this.handleDropData}
                                    openDrop={this.state.openDrop['onward']['concessionType'] && this.state.openDropSeatNo === el}
                                    seatsData={seats[el]}
                                />

                                <LineInpDrop
                                    type="text"
                                    value={seats[el].idCardType || ""}
                                    onClick={() => this.clickHandler('idCardType', 'onward', seats[el], el)}
                                    placeholder="Id Card "
                                    name={"paxIDCardType[" + index + "]"}
                                    style={{ width: "14%" }}
                                    tab={index * 4 + 7}
                                    readOnly={true}
                                    seatNo={el}
                                    data={this.state.idCardData}
                                    dropType={'onward_idCardType'}
                                    handleDropData={this.handleDropData}
                                    openDrop={this.state.openDrop['onward']['idCardType'] && this.state.openDropSeatNo === el}
                                    seatsData={seats[el]}
                                />

                                <LineInp
                                    type="tel"
                                    value={seats[el].idCardNo || ""}
                                    handleChange={(e) => {
                                        const val = e.target.value;
                                        store.dispatch(updateUserInfo("idCardNo", "onward", el, val));
                                    }}
                                    placeholder="ID Card No"
                                    max={12}
                                    name={"paxIDCardNo[" + index + "]"}
                                    style={{ width: "14%" }}
                                    tab={index * 4 + 8}
                                />

                                <LineInpDrop
                                    type="text"
                                    value={seats[el].nationality || ""}
                                    onClick={() => this.clickHandler('country', 'onward', seats[el], el)}
                                    placeholder="Country"
                                    name={"paxNationality[" + index + "]"}
                                    style={{ width: "10%" }}
                                    tab={index * 4 + 9}
                                    readOnly={true}
                                    seatNo={el}
                                    data={this.state.nationality}
                                    dropType={'onward_country'}
                                    handleDropData={this.handleDropData}
                                    openDrop={this.state.openDrop['onward']['country'] && this.state.openDropSeatNo === el}
                                    seatsData={seats[el]}
                                />
                            </div>
                        );
                    })}
                </React.Fragment>
            );
        } else {
            return <div className="card">Loading...</div>;
        }
    };

    enterPassDetailsReturn = () => {
        const loop = this.props.search.order.return.seats;
        const seats = this.props.search.order.return.seatDetails;
        const onwardCount = this.props.search.order.onward.seats.length * 4;
        const urlParams = new URLSearchParams(window.location.search);
        const linkfromstoptocity = urlParams.get("linkfromstoptocity");
        return (
            <React.Fragment>
                <div className="passenger--trip--head">{this.state.reviewEng ? `Return Trip Passenger${loop.length > 1 ? 's' : ''}` : `ಹಿಂದೆ ಹೋಗುವ ಪ್ರಯಾಣಿಕ`}</div>
                {loop.map((el, index) => {
                    return (
                        <div className="pass-info" key={{ index }}>
                            <div
                                style={{
                                    position: "relative",
                                    width: "45px",
                                    height: "45px",
                                    fontSize: "14px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    border: "2px solid",
                                    borderColor: seats[el].isMale
                                        ? color.grey
                                        : seats[el].isFemale
                                            ? color.female
                                            : color.grey,
                                    borderRadius: color.borderRadius,
                                }}
                            >
                                {el}
                                <span
                                    style={{
                                        position: "absolute",
                                        bottom: 0,
                                        left: "5px",
                                        width: "23px",
                                        height: "4px",
                                        background: seats[el].isMale
                                            ? color.grey
                                            : seats[el].isFemale
                                                ? color.female
                                                : color.grey,
                                        borderRadius: color.borderRadius,
                                    }}
                                ></span>
                            </div>
                            <PastInput
                                value={seats[el].name}
                                handleSelect={this.handlepastlist}
                                handleChange={this.handleListInput}
                                name={"paxName2[" + index + "]"}
                                placeholder="Name"
                                style={{ width: "18%" }}
                                filedname="name"
                                triptype="return"
                                seatno={el}
                                tab={index * 4 + 3 + onwardCount}
                            />
                            <LineInpDrop
                                type="text"
                                value={this.setGender(seats[el].gender) || ""}
                                // handleChange={(e) => {
                                //   index === 0
                                //     ? this.setState({ customerAge: e.target.value })
                                //     : "";
                                //   const val = isInteger(parseInt(e.target.value, 10))
                                //     ? parseInt(e.target.value, 10)
                                //     : !e.target.value
                                //       ? ""
                                //       : seats[el].age;
                                //   store.dispatch(updateUserInfo("age", "onward", el, val));
                                // }}
                                onClick={() => {
                                    this.clickHandler('gender', 'return', seats[el], el);
                                    // this.checkConcessionTypeList(seats[el].gender, 'gender', 'return')
                                    // this.checkConcessionTypeList(seats[el].age, 'age', 'return')
                                    this.checkConcessionTypeList(seats[el].gender, seats[el].age, 'gender', 'age', 'return')
                                }
                                }
                                placeholder="Gender"
                                name={"paxGender2[" + index + "]"}
                                style={{ width: "10%" }}
                                tab={index * 4 + 4}
                                seatNo={el}
                                readOnly={true}
                                disabled={(seats[el].isFemale || seats[el].isMale) ? true : false}
                                dropType={'return_gender'}
                                data={this.state.genderData}
                                openDrop={this.state.openDrop['return']['gender'] && this.state.openDropSeatNo === el}
                                handleDropData={this.handleDropData}
                                seatsData={seats[el]}
                            />
                            <LineInp
                                type="tel"
                                value={seats[el].age || ""}
                                handleChange={(e) => {
                                    index === 0
                                        ? this.setState({ customerAge: e.target.value })
                                        : "";
                                    const val = isInteger(parseInt(e.target.value, 10))
                                        ? parseInt(e.target.value, 10)
                                        : !e.target.value
                                            ? ""
                                            : seats[el].age;
                                    store.dispatch(updateUserInfo("age", "return", el, val));
                                    store.dispatch(updateUserInfo("concessionType", "return", el, ""));
                                    //this.checkConcessionTypeList(seats[el].age, "age", 'return');
                                    this.checkConcessionTypeList(seats[el].gender, seats[el].age, 'gender', 'age', 'return')
                                    this.reCalculateFare('return', el, seats[el].age + '');
                                    this.updateReturnLevy(seats[el], this.state.returnLevyConcData, 'age');
                                    this.updateReturnConcessionInfo(seats[el]);
                                    this.updateConcessionAmount('return');
                                }}
                                placeholder="Age"
                                name={"paxAge2[" + index + "]"}
                                style={{ width: "8%" }}
                                tab={index * 4 + 5}
                                max={2}
                            />
                            <LineInpDrop
                                type="text"
                                value={seats[el].concessionType || ""}
                                onClick={() => {
                                    this.clickHandler('concessionType', 'return', seats[el], el)
                                    // this.checkConcessionTypeList(seats[el].age, 'age', 'return')
                                    // this.checkConcessionTypeList(seats[el].gender, 'gender', 'return');
                                    this.checkConcessionTypeList(seats[el].gender, seats[el].age, 'gender', 'age', 'return')
                                }}
                                placeholder="Concession"
                                name={"paxConcessionType2[" + index + "]"}
                                style={{ width: "18%" }}
                                tab={index * 4 + 6}
                                readOnly={true}
                                seatNo={el}
                                dropType={'return_concession'}
                                // data={this.state.returnConcessionType[el]}
                                data={this.getConcessionData('return', seats[el], el)[el] || []}
                                handleDropData={this.handleDropData}
                                openDrop={this.state.openDrop['return']['concessionType'] && this.state.openDropSeatNo === el}
                                seatsData={seats[el]}
                            />

                            <LineInpDrop
                                type="text"
                                value={seats[el].idCardType || ""}
                                onClick={() => this.clickHandler('idCardType', 'return', seats[el], el)}
                                placeholder="Id Card "
                                name={"paxIDCardType2[" + index + "]"}
                                style={{ width: "14%" }}
                                tab={index * 4 + 7}
                                readOnly={true}
                                seatNo={el}
                                data={this.state.idCardData}
                                dropType={'return_idCardType'}
                                handleDropData={this.handleDropData}
                                openDrop={this.state.openDrop['return']['idCardType'] && this.state.openDropSeatNo === el}
                                seatsData={seats[el]}
                            />

                            <LineInp
                                type="tel"
                                value={seats[el].idCardNo || ""}
                                handleChange={(e) => {
                                    const val = e.target.value;
                                    store.dispatch(updateUserInfo("idCardNo", "return", el, val));
                                }}
                                placeholder="ID Card No"
                                max={12}
                                name={"paxIDCardNo2[" + index + "]"}
                                style={{ width: "14%" }}
                                tab={index * 4 + 8}
                            />

                            <LineInpDrop
                                type="text"
                                value={seats[el].nationality || ""}
                                onClick={() => this.clickHandler('country', 'return', seats[el], el)}
                                placeholder="Country"
                                name={"paxNationality2[" + index + "]"}
                                style={{ width: "10%" }}
                                tab={index * 4 + 9}
                                readOnly={true}
                                seatNo={el}
                                data={this.state.nationality}
                                dropType={'return_country'}
                                handleDropData={this.handleDropData}
                                openDrop={this.state.openDrop['return']['country'] && this.state.openDropSeatNo === el}
                                seatsData={seats[el]}
                            />

                        </div>
                    );
                })}
            </React.Fragment>
        );
    };

    setTncFLag = (value) => {
        this.setState({ tcFlag: value })
    }

    render() {
        // console.log("order", this.props.search.order);
        // console.log("props", this.props);
        // console.log("onwardConcessionUsed", this.state.onwardConcessionUsed);
        // console.log("onwardLevyConcDetails", this.props.search.levyandConcData);
        // console.log("updatedOnwardFare", this.state.updatedOnwardFare);
        // console.log("updatedRetrunFare", this.state.updatedReturnFare);

        let that = this;
        that.showOpDiscountConfirmBox();
        let amountToPay = 0;
        amountToPay =
            that.state.updatedOnwardFare +
            that.state.updatedReturnFare +
            that.state.onwardSc +
            that.state.returnSc +
            that.state.onwardGst +
            that.state.returnGst +
            this.state.onwardPickcharges +
            this.state.onwardDropcharges +
            this.state.returnPickcharges +
            this.state.returnDropcharges -
            this.state.roundTripdiscount +
            that.state.insuranceVal -
            that.state.discount -
            parseInt(
                that.state.CouponDiscountAmt +
                that.state.CouponDiscountAmt2 +
                that.state.CouponDiscountAmt3,
                10
            );
        var bankCharges = Math.ceil(
            (that.state.bankChargesPer * amountToPay) / 100
        );

        const order = this.props.search.order;
        return (
            <div key="checkoutpage">
                {/* {window.msurl === 'shrinath.biz' ? <HeaderSTA /> : <Header />} */}
                <HeaderNew />
                {that.state.alerterror !== "" ? that.showaertdialogue() : ""}
                <section className="checkout-wrapper" key="checkout-wrapper">
                    <div className="left-div" key="3ss"
                        style={{ width: '75%', background: '#fff', height: '560px', overflowY: 'auto' }}>
                        <form
                            key="dssfd"
                            id="checkoutForm"
                            method="POST"
                            action={window.url + "/co/confirm"}
                        >
                            <input type="hidden" name="query" value={that.state.queryData} />
                            <input
                                type="hidden"
                                name="o"
                                id="o"
                                value={that.props.match.params.token}
                            />
                            <input type="hidden" name="owo" value="0" />
                            <input type="hidden" name="method" id="method" value="1" />
                            <input type="hidden" name="provider" id="provider" value="1" />
                            <input
                                type="hidden"
                                name="hd_charges"
                                id="hd_charges"
                                value="0"
                            />
                            <input
                                type="hidden"
                                name="coupon"
                                id="coupon"
                                value={this.state.validCouponName}
                            />
                            <input
                                type="hidden"
                                name="countrycode"
                                id="countrycode"
                                value={"+91"}
                            />
                            <input
                                type="hidden"
                                name="mobile"
                                id="mobile"
                                value={that.state.mobile}
                            />
                            <input
                                type="hidden"
                                name="mobileNo"
                                id="mobileNo"
                                value={that.state.mobile}
                            />
                            <input
                                type="hidden"
                                name="email"
                                id="email"
                                value={that.state.email}
                            />
                            <input
                                type="hidden"
                                name="couponID"
                                id="couponID"
                                value={that.state.CouponID}
                            />
                            <input
                                type="hidden"
                                name="onwardRoundOff"
                                value={that.state.onwardRoundingAmt}
                            />
                            <input
                                type="hidden"
                                name="couponID2"
                                id="couponID2"
                                value={that.state.CouponID2}
                            />
                            <input
                                type="hidden"
                                name="couponID3"
                                id="couponID3"
                                value={that.state.CouponID3}
                            />
                            <input
                                type="hidden"
                                name="couponAmount"
                                id="couponAmount"
                                value={that.state.CouponDiscountAmt}
                            />
                            <input
                                type="hidden"
                                name="couponAmount2"
                                id="couponAmount2"
                                value={that.state.CouponDiscountAmt2}
                            />
                            <input
                                type="hidden"
                                name="couponAmount3"
                                id="couponAmount3"
                                value={that.state.CouponDiscountAmt3}
                            />
                            {that.props.search.order.showInsurance && (
                                <input
                                    type="hidden"
                                    name="insurance"
                                    value={that.state.insurance}
                                />
                            )}

                            {
                                order && order.onward && order.onward.seatDetails && Object.keys(order.onward.seatDetails).length > 0 && Object.keys(order.onward.seatDetails).map((el, index) => (
                                    <React.Fragment key={el}>
                                        <input type='hidden' name={`paxName[${index}]`} value={order.onward.seatDetails[el].name || ''} />
                                        <input type='hidden' name={`paxGender[${index}]`} value={order.onward.seatDetails[el].gender || ''} />
                                        <input type='hidden' name={`paxAge[${index}]`} value={order.onward.seatDetails[el].age || ''} />
                                        <input type='hidden' name={`paxConcessionType[${index}]`} value={order.onward.seatDetails[el].concessionType || ''} />
                                        <input type='hidden' name={`paxIDCardNo[${index}]`} value={order.onward.seatDetails[el].idCardNo || ''} />
                                        <input type='hidden' name={`paxIDCardType[${index}]`} value={order.onward.seatDetails[el].idCardType || ''} />
                                        <input type='hidden' name={`paxNationality[${index}]`} value={order.onward.seatDetails[el].nationality || ''} />
                                    </React.Fragment>
                                ))

                            }
                            <input type="hidden" name="PGType" value={this.state.payopt} />
                            <div key="334sa43">

                                <div
                                    key="was43"
                                    className="block"
                                >
                                    <div className="card" key="reviewdeatils" style={{ background: 'initial', overflowY: 'inherit', height: 'inherit' }}>
                                        {this.reviewInfo('onward')}

                                        {this.enterPassDetailsOnwards()}
                                        <div className="onwarddata" style={{ padding: '15px 0' }}>
                                            {this.showKASRTConwardFaredetails(this.props.search.order)}
                                        </div>
                                        {
                                            this.props.search.order.length !== 0 &&
                                            this.props.search.order.return &&
                                            this.props.search.order.return.seats &&
                                            <React.Fragment>
                                                {this.reviewInfo('return')}
                                                {this.enterPassDetailsReturn()}
                                                <div className="onwarddata" style={{ padding: '15px 0' }}>
                                                    {this.showKASRTCreturnFaredetails(that.props.search.order)}
                                                </div>
                                            </React.Fragment>

                                        }


                                    </div>


                                </div>
                            </div>
                        </form>
                    </div>
                    <div className="right-div" style={{ width: '25%', height: '560px', background: '#fff', position: 'relative' }}>
                        <div>
                            <div
                                className="block"
                            >
                                <div style={{ fontSize: '18px', fontWeight: '500', color: '#202020', padding: '16px 0 0 16px' }}>Select Payment Gateway</div>
                                <div className="onwarddata" style={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                                    {this.selPaymentOption()}
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                {window.msurl === 'shrinath.biz' ? <FooterSTA /> : <Footer />}
                {that.state.showLoader ? (
                    <div className="show-load">
                        <div className="loading">
                            <span></span>
                            <span></span>
                            <span></span>
                        </div>
                    </div>
                ) : (
                    ""
                )}
                {this.state.alertFlag &&
                    < AlertTerms
                        msg={"hello roushan"}
                        error={false}
                        className="login--alert"
                        setTncFLag={this.setTncFLag}
                        close={() => {
                            this.setState({ alertFlag: false })
                        }}
                    />

                }
            </div>
        );

    }
}

const mapStateToProps = function (store) {
    return store;
};

export default connect(mapStateToProps)(CheckoutNew2);
